require("core-js/modules/es.regexp.flags.js");
!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t(require("react")) : "function" == typeof define && define.amd ? define(["react"], t) : "object" == typeof exports ? exports["embed-react"] = t(require("react")) : e["embed-react"] = t(e.react);
}(this, function (e) {
  return function () {
    var t = {
        378: function (e) {
          "use strict";

          e.exports = function e(t, n) {
            if (t === n) return !0;
            if (t && n && "object" == typeof t && "object" == typeof n) {
              if (t.constructor !== n.constructor) return !1;
              var o, r, i;
              if (Array.isArray(t)) {
                if ((o = t.length) != n.length) return !1;
                for (r = o; 0 != r--;) if (!e(t[r], n[r])) return !1;
                return !0;
              }
              if (t.constructor === RegExp) return t.source === n.source && t.flags === n.flags;
              if (t.valueOf !== Object.prototype.valueOf) return t.valueOf() === n.valueOf();
              if (t.toString !== Object.prototype.toString) return t.toString() === n.toString();
              if ((o = (i = Object.keys(t)).length) !== Object.keys(n).length) return !1;
              for (r = o; 0 != r--;) if (!Object.prototype.hasOwnProperty.call(n, i[r])) return !1;
              for (r = o; 0 != r--;) {
                var a = i[r];
                if (!e(t[a], n[a])) return !1;
              }
              return !0;
            }
            return t != t && n != n;
          };
        },
        145: function (e, t, n) {
          "use strict";

          n.r(t), t.default = '@keyframes spin{to{transform:rotate(360deg)}}.tf-v1-popover{bottom:96px;position:fixed;right:16px;z-index:10001}.tf-v1-popover.open{max-width:100%;min-height:360px;min-width:360px}.tf-v1-popover-wrapper{position:absolute;top:50%;left:50%;transform:translate(-50%, -50%);height:100%;width:100%;opacity:0;transition:opacity .25s ease-in-out;border-radius:4px;box-shadow:rgba(0,0,0,.08) 0 2px 4px,rgba(0,0,0,.06) 0 2px 12px}.tf-v1-popover-wrapper iframe{width:100%;height:100%;border:none;overflow:hidden;border-radius:8px}.tf-v1-popover-close{display:none}.tf-v1-popover-button{width:54px;height:54px;position:fixed;box-shadow:0 2px 12px rgba(0,0,0,.06),0 2px 4px rgba(0,0,0,.08);color:#fff;right:26px;bottom:26px;border-radius:50%;display:flex;align-items:center;justify-content:center;cursor:pointer;background:#3a7685;line-height:0;border:none;padding:0}.tf-v1-popover-button-icon{width:54px;height:54px;font-size:24px;border-radius:50%;overflow:hidden;display:flex;justify-content:center;align-items:center}.tf-v1-popover-button-icon svg.default{margin-top:6px}.tf-v1-popover-button-icon svg,.tf-v1-popover-button-icon img{max-width:54px;max-height:54px}.tf-v1-popover-button-icon img{width:100%;height:100%;object-fit:cover;border-radius:50%}.tf-v1-popover-tooltip{position:fixed;right:94px;bottom:33px;max-width:240px;padding:10px 25px 10px 10px;border-radius:8px;background:#fff;box-shadow:0 2px 4px rgba(0,0,0,.08),0 2px 12px rgba(0,0,0,.06);font-size:14px;font-family:Helvetica,Arial,sans-serif;line-height:22px}.tf-v1-popover-tooltip::before{background-color:#fff;content:"";display:block;width:12px;height:12px;position:absolute;right:-4px;bottom:15px;transform:rotate(45deg);box-shadow:2px -2px 2px 0 rgba(0,0,0,.06)}.tf-v1-popover-tooltip-text{overflow:hidden}.tf-v1-popover-tooltip-close{color:rgba(0,0,0,.2);cursor:pointer;margin-left:4px;display:inline-block;width:20px;height:20px;font-size:18px;text-align:center;position:absolute;top:8px;right:6px}.tf-v1-popover-tooltip-close:hover{color:rgba(0,0,0,.3)}.tf-v1-popover-tooltip.closing{transition:opacity .25s ease-in-out;opacity:0}.tf-v1-popover-unread-dot{width:8px;height:8px;border-radius:50%;background-color:#fa6b05;border:2px solid #fff;position:absolute;top:2px;right:2px}.tf-v1-popover-unread-dot.closing{transition:opacity .25s ease-in-out;opacity:0}.tf-v1-spinner{border:3px solid #aaa;font-size:40px;width:1em;height:1em;border-radius:.5em;box-sizing:border-box;animation:spin 1s linear infinite;border-top-color:#fff;position:absolute;top:50%;left:50%;margin:-20px 0 0 -20px}@media(max-width: 480px){.tf-v1-popover.open{top:0;left:0;bottom:0;right:0;width:100% !important;height:100% !important}.tf-v1-popover.open .tf-v1-popover-close{display:block}.tf-v1-popover-wrapper{border-radius:0;box-shadow:none}.tf-v1-popover-wrapper iframe{border-radius:0}.tf-v1-popover-close{display:block;padding:0;margin:0;position:absolute;font-size:32px;font-weight:normal;line-height:24px;width:24px;height:24px;text-align:center;text-transform:none;cursor:pointer;opacity:.75;transition:opacity .25s ease-in-out;text-decoration:none;color:#000;top:6px;right:8px;background:none;border:none;border-radius:0;z-index:1;opacity:0}.tf-v1-popover-close:hover{opacity:1}}@media(max-width: 480px)and (min-width: 481px){.tf-v1-popover-close{color:#fff !important}}@media(max-width: 480px){.tf-v1-popover-button{width:44px;height:44px;right:8px;bottom:8px}.tf-v1-popover-button-icon{font-size:20px}.tf-v1-popover-button-icon svg{margin-top:4px;max-height:24px;max-width:24px}.tf-v1-popover-button-icon img{max-width:44px;max-height:44px}.tf-v1-popover-tooltip{position:fixed;right:66px;bottom:8px;left:auto;font-size:12px}.tf-v1-popover-tooltip::before{bottom:14px}.tf-v1-popover-unread-dot{top:0;right:0}.tf-v1-spinner{border:3px solid #aaa;font-size:32px;width:1em;height:1em;border-radius:.5em;box-sizing:border-box;animation:spin 1s linear infinite;border-top-color:#fff;position:absolute;top:50%;left:50%;margin:-16px 0 0 -16px}}';
        },
        792: function (e, t, n) {
          "use strict";

          n.r(t), t.default = "@keyframes spin{to{transform:rotate(360deg)}}.tf-v1-popup{position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,.75);transition:opacity .25s ease-in-out;z-index:10001;display:flex;align-items:center;justify-content:center}.tf-v1-popup .tf-v1-iframe-wrapper{position:relative;transition:opacity .25s ease-in-out;min-width:360px;min-height:360px}.tf-v1-popup .tf-v1-iframe-wrapper iframe{width:100%;height:100%;border:none;overflow:hidden;border-radius:8px}.tf-v1-popup .tf-v1-close{display:block;padding:0;margin:0;position:absolute;font-size:32px;font-weight:normal;line-height:24px;width:24px;height:24px;text-align:center;text-transform:none;cursor:pointer;opacity:.75;transition:opacity .25s ease-in-out;text-decoration:none;color:#000;top:-34px;right:0;background:none;border:none;border-radius:0}.tf-v1-popup .tf-v1-close:hover{opacity:1}@media(min-width: 481px){.tf-v1-popup .tf-v1-close{color:#fff !important}}.tf-v1-popup .tf-v1-spinner{border:3px solid #aaa;font-size:40px;width:1em;height:1em;border-radius:.5em;box-sizing:border-box;animation:spin 1s linear infinite;border-top-color:#fff;position:absolute;top:50%;left:50%;margin:-20px 0 0 -20px}@media(max-width: 480px){.tf-v1-popup{width:100% !important;height:100% !important}.tf-v1-popup .tf-v1-iframe-wrapper{position:relative;transition:opacity .25s ease-in-out;min-width:100%;min-height:100%}.tf-v1-popup .tf-v1-iframe-wrapper iframe{border-radius:0}.tf-v1-popup .tf-v1-close{display:block;padding:0;margin:0;position:absolute;font-size:32px;font-weight:normal;line-height:24px;width:24px;height:24px;text-align:center;text-transform:none;cursor:pointer;opacity:.75;transition:opacity .25s ease-in-out;text-decoration:none;color:#000;top:6px;right:8px;background:none;border:none;border-radius:0}.tf-v1-popup .tf-v1-close:hover{opacity:1}}@media(max-width: 480px)and (min-width: 481px){.tf-v1-popup .tf-v1-close{color:#fff !important}}";
        },
        838: function (e, t, n) {
          "use strict";

          n.r(t), t.default = "@keyframes spin{to{transform:rotate(360deg)}}.tf-v1-sidetab{position:fixed;top:50%;right:0;width:400px;height:580px;transform:translate(100%, -50%);box-shadow:0 2px 4px rgba(0,0,0,.08),0 2px 12px rgba(0,0,0,.06);z-index:10001;will-change:transform}.tf-v1-sidetab.ready{transition:transform 400ms cubic-bezier(0.5, 0, 0.75, 0)}.tf-v1-sidetab iframe{width:100%;height:100%;border:none;overflow:hidden;border-radius:8px 0 0 8px}.tf-v1-sidetab.open{transform:translate(0, -50%)}.tf-v1-sidetab-wrapper{position:relative;height:100%}.tf-v1-sidetab-button{position:absolute;top:50%;left:-48px;transform:rotate(-90deg) translateX(-50%);transform-origin:left top;min-width:100px;max-width:540px;height:48px;display:flex;align-items:center;padding:12px 16px;border-radius:8px 8px 0 0;color:#fff;box-shadow:0 2px 4px rgba(0,0,0,.08),0 2px 12px rgba(0,0,0,.06);background-color:#3a7685;cursor:pointer;border:0;text-decoration:none;outline:none}.tf-v1-sidetab-button-text{flex:1;font-size:18px;font-family:Helvetica,Arial,sans-serif;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.tf-v1-sidetab-button-icon{width:24px;height:24px;font-size:24px;transform:rotate(90deg);margin-right:12px;position:relative;order:-1}.tf-v1-sidetab-button-icon>img{width:100%;height:100%;object-fit:contain}.tf-v1-sidetab-close{display:none}.tf-v1-sidetab .tf-v1-spinner{border:3px solid #aaa;font-size:24px;width:1em;height:1em;border-radius:.5em;box-sizing:border-box;animation:spin 1s linear infinite;border-top-color:#fff;position:absolute;top:50%;left:50%;margin:-12px 0 0 -12px;top:0;left:0;margin:0}@media(max-width: 480px){.tf-v1-sidetab{transition:unset}.tf-v1-sidetab.ready{transition:unset}.tf-v1-sidetab.open{top:0;left:0;right:0;bottom:0;transform:translate(0, 0);width:100% !important;height:100% !important}.tf-v1-sidetab-close{display:block;padding:0;margin:0;position:absolute;font-size:32px;font-weight:normal;line-height:24px;width:24px;height:24px;text-align:center;text-transform:none;cursor:pointer;opacity:.75;transition:opacity .25s ease-in-out;text-decoration:none;color:#000;top:6px;right:8px;background:none;border:none;border-radius:0;display:block;z-index:1}.tf-v1-sidetab-close:hover{opacity:1}}@media(max-width: 480px)and (min-width: 481px){.tf-v1-sidetab-close{color:#fff !important}}";
        },
        630: function (e, t, n) {
          "use strict";

          n.r(t), t.default = "@keyframes spin{to{transform:rotate(360deg)}}.tf-v1-slider{position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,.75);transition:opacity .25s ease-in-out;z-index:10001}.tf-v1-slider .tf-v1-iframe-wrapper{max-width:calc(100vw - 26px);height:100%;position:absolute;top:0;transition:right .5s ease-in-out,left .5s ease-in-out}.tf-v1-slider .tf-v1-iframe-wrapper iframe{width:100%;height:100%;border:none;overflow:hidden;border-radius:0}@media(min-width: 481px){.tf-v1-slider .tf-v1-iframe-wrapper iframe{border-radius:8px 0 0 8px}}.tf-v1-slider .tf-v1-close{display:block;padding:0;margin:0;position:absolute;font-size:32px;font-weight:normal;line-height:24px;width:24px;height:24px;text-align:center;text-transform:none;cursor:pointer;opacity:.75;transition:opacity .25s ease-in-out;text-decoration:none;color:#000;top:6px;right:8px;background:none;border:none;border-radius:0}.tf-v1-slider .tf-v1-close:hover{opacity:1}@media(min-width: 481px){.tf-v1-slider .tf-v1-close{color:#fff !important}}@media(min-width: 481px){.tf-v1-slider .tf-v1-close{top:4px;left:-26px}}.tf-v1-slider .tf-v1-close:hover{opacity:1}.tf-v1-slider .tf-v1-spinner{border:3px solid #aaa;font-size:40px;width:1em;height:1em;border-radius:.5em;box-sizing:border-box;animation:spin 1s linear infinite;border-top-color:#fff;position:absolute;top:50%;left:50%;margin:-20px 0 0 -20px}@media(min-width: 481px){.tf-v1-slider.left .tf-v1-iframe-wrapper iframe{border-radius:0 8px 8px 0}.tf-v1-slider.left .tf-v1-close{left:auto;right:-24px}}@media(max-width: 480px){.tf-v1-slider{width:100% !important;height:100% !important}.tf-v1-slider .tf-v1-iframe-wrapper{width:100% !important;max-width:100vw;height:100%;transition:unset}.tf-v1-slider .tf-v1-iframe-wrapper iframe{border-radius:none}.tf-v1-slider .tf-v1-close{display:block;padding:0;margin:0;position:absolute;font-size:32px;font-weight:normal;line-height:24px;width:24px;height:24px;text-align:center;text-transform:none;cursor:pointer;opacity:.75;transition:opacity .25s ease-in-out;text-decoration:none;color:#000;top:6px;right:8px;background:none;border:none;border-radius:0;left:auto}.tf-v1-slider .tf-v1-close:hover{opacity:1}}@media(max-width: 480px)and (min-width: 481px){.tf-v1-slider .tf-v1-close{color:#fff !important}}";
        },
        684: function (e, t, n) {
          "use strict";

          n.r(t), t.default = ".tf-v1-widget{width:100%;height:100%;min-height:inherit;position:relative}.tf-v1-widget iframe{width:100%;height:100%;border:none;overflow:hidden;border-radius:8px;min-height:inherit}.tf-v1-widget-close{display:none}.tf-v1-widget-iframe-overlay{width:100%;height:100%;border:none;overflow:hidden;border-radius:8px;position:absolute;top:0;left:0}.tf-v1-widget-fullscreen{position:fixed;top:0;left:0;right:0;bottom:0;z-index:10001;width:100% !important;height:100% !important}.tf-v1-widget-fullscreen .tf-v1-widget-close{display:block;display:block;padding:0;margin:0;position:absolute;font-size:32px;font-weight:normal;line-height:24px;width:24px;height:24px;text-align:center;text-transform:none;cursor:pointer;opacity:.75;transition:opacity .25s ease-in-out;text-decoration:none;color:#000;top:6px;right:8px;background:none;border:none;border-radius:0;z-index:1}.tf-v1-widget-fullscreen .tf-v1-widget-close:hover{opacity:1}@media(min-width: 481px){.tf-v1-widget-fullscreen .tf-v1-widget-close{color:#fff !important}}.tf-v1-widget-fullscreen iframe{border-radius:0}";
        },
        281: function (e, t, n) {
          "use strict";

          var o = this && this.__createBinding || (Object.create ? function (e, t, n, o) {
              void 0 === o && (o = n);
              var r = Object.getOwnPropertyDescriptor(t, n);
              r && !("get" in r ? !t.__esModule : r.writable || r.configurable) || (r = {
                enumerable: !0,
                get: function () {
                  return t[n];
                }
              }), Object.defineProperty(e, o, r);
            } : function (e, t, n, o) {
              void 0 === o && (o = n), e[o] = t[n];
            }),
            r = this && this.__exportStar || function (e, t) {
              for (var n in e) "default" === n || Object.prototype.hasOwnProperty.call(t, n) || o(t, e, n);
            };
          Object.defineProperty(t, "__esModule", {
            value: !0
          }), r(n(11), t), r(n(739), t), r(n(860), t);
        },
        794: function (e, t, n) {
          "use strict";

          var o = this && this.__assign || function () {
              return o = Object.assign || function (e) {
                for (var t, n = 1, o = arguments.length; n < o; n++) for (var r in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
                return e;
              }, o.apply(this, arguments);
            },
            r = this && this.__importDefault || function (e) {
              return e && e.__esModule ? e : {
                default: e
              };
            };
          Object.defineProperty(t, "__esModule", {
            value: !0
          }), t.InlineStyle = void 0;
          var i = r(n(156)),
            a = r(n(52));
          t.InlineStyle = function (e) {
            var t = e.filename,
              r = n(367)("./".concat(t, ".css")),
              s = (0, a.default)();
            return i.default.createElement("style", o({}, s ? {
              nonce: s
            } : {}), r.default);
          };
        },
        11: function (e, t, n) {
          "use strict";

          var o = this && this.__assign || function () {
              return o = Object.assign || function (e) {
                for (var t, n = 1, o = arguments.length; n < o; n++) for (var r in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
                return e;
              }, o.apply(this, arguments);
            },
            r = this && this.__createBinding || (Object.create ? function (e, t, n, o) {
              void 0 === o && (o = n);
              var r = Object.getOwnPropertyDescriptor(t, n);
              r && !("get" in r ? !t.__esModule : r.writable || r.configurable) || (r = {
                enumerable: !0,
                get: function () {
                  return t[n];
                }
              }), Object.defineProperty(e, o, r);
            } : function (e, t, n, o) {
              void 0 === o && (o = n), e[o] = t[n];
            }),
            i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
              Object.defineProperty(e, "default", {
                enumerable: !0,
                value: t
              });
            } : function (e, t) {
              e.default = t;
            }),
            a = this && this.__importStar || function (e) {
              if (e && e.__esModule) return e;
              var t = {};
              if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && r(t, e, n);
              return i(t, e), t;
            },
            s = this && this.__rest || function (e, t) {
              var n = {};
              for (var o in e) Object.prototype.hasOwnProperty.call(e, o) && t.indexOf(o) < 0 && (n[o] = e[o]);
              if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
                var r = 0;
                for (o = Object.getOwnPropertySymbols(e); r < o.length; r++) t.indexOf(o[r]) < 0 && Object.prototype.propertyIsEnumerable.call(e, o[r]) && (n[o[r]] = e[o[r]]);
              }
              return n;
            };
          Object.defineProperty(t, "__esModule", {
            value: !0
          }), t.makeButtonComponent = t.emptyEmbed = void 0;
          var u = a(n(156)),
            c = n(794);
          t.emptyEmbed = {
            unmount: function () {},
            open: function () {}
          }, t.makeButtonComponent = function (e, n) {
            return u.default.forwardRef(function (r, i) {
              var a = r.id,
                l = r.children,
                d = r.as,
                f = void 0 === d ? "button" : d,
                p = r.style,
                v = void 0 === p ? {} : p,
                m = r.className,
                h = void 0 === m ? "" : m,
                b = r.buttonProps,
                g = s(r, ["id", "children", "as", "style", "className", "buttonProps"]),
                y = (0, u.useRef)(t.emptyEmbed),
                w = i || y;
              (0, u.useEffect)(function () {
                return w.current = e(a, g), function () {
                  return w.current.unmount();
                };
              }, [a, g, w]);
              var x = (0, u.useMemo)(function () {
                  return function () {
                    return w.current.open();
                  };
                }, [w]),
                O = u.default.createElement(f, o({
                  style: v,
                  className: h,
                  onClick: x,
                  "data-testid": "tf-v1-".concat(n),
                  children: l
                }, b));
              return u.default.createElement(u.default.Fragment, null, u.default.createElement(c.InlineStyle, {
                filename: n
              }), O);
            });
          };
        },
        739: function (e, t, n) {
          "use strict";

          var o = this && this.__createBinding || (Object.create ? function (e, t, n, o) {
              void 0 === o && (o = n);
              var r = Object.getOwnPropertyDescriptor(t, n);
              r && !("get" in r ? !t.__esModule : r.writable || r.configurable) || (r = {
                enumerable: !0,
                get: function () {
                  return t[n];
                }
              }), Object.defineProperty(e, o, r);
            } : function (e, t, n, o) {
              void 0 === o && (o = n), e[o] = t[n];
            }),
            r = this && this.__setModuleDefault || (Object.create ? function (e, t) {
              Object.defineProperty(e, "default", {
                enumerable: !0,
                value: t
              });
            } : function (e, t) {
              e.default = t;
            }),
            i = this && this.__importStar || function (e) {
              if (e && e.__esModule) return e;
              var t = {};
              if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
              return r(t, e), t;
            },
            a = this && this.__rest || function (e, t) {
              var n = {};
              for (var o in e) Object.prototype.hasOwnProperty.call(e, o) && t.indexOf(o) < 0 && (n[o] = e[o]);
              if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
                var r = 0;
                for (o = Object.getOwnPropertySymbols(e); r < o.length; r++) t.indexOf(o[r]) < 0 && Object.prototype.propertyIsEnumerable.call(e, o[r]) && (n[o[r]] = e[o[r]]);
              }
              return n;
            };
          Object.defineProperty(t, "__esModule", {
            value: !0
          }), t.makeInitializerComponent = void 0;
          var s = i(n(156)),
            u = n(794),
            c = {
              unmount: function () {}
            };
          t.makeInitializerComponent = function (e, t) {
            return s.default.forwardRef(function (n, o) {
              var r = n.id,
                i = a(n, ["id"]),
                l = (0, s.useRef)(c),
                d = o || l;
              return (0, s.useEffect)(function () {
                return d.current = e(r, i), function () {
                  d.current.unmount();
                };
              }, [r, i, d]), s.default.createElement(u.InlineStyle, {
                filename: t
              });
            });
          };
        },
        860: function (e, t, n) {
          "use strict";

          var o = this && this.__assign || function () {
              return o = Object.assign || function (e) {
                for (var t, n = 1, o = arguments.length; n < o; n++) for (var r in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
                return e;
              }, o.apply(this, arguments);
            },
            r = this && this.__createBinding || (Object.create ? function (e, t, n, o) {
              void 0 === o && (o = n);
              var r = Object.getOwnPropertyDescriptor(t, n);
              r && !("get" in r ? !t.__esModule : r.writable || r.configurable) || (r = {
                enumerable: !0,
                get: function () {
                  return t[n];
                }
              }), Object.defineProperty(e, o, r);
            } : function (e, t, n, o) {
              void 0 === o && (o = n), e[o] = t[n];
            }),
            i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
              Object.defineProperty(e, "default", {
                enumerable: !0,
                value: t
              });
            } : function (e, t) {
              e.default = t;
            }),
            a = this && this.__importStar || function (e) {
              if (e && e.__esModule) return e;
              var t = {};
              if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && r(t, e, n);
              return i(t, e), t;
            },
            s = this && this.__rest || function (e, t) {
              var n = {};
              for (var o in e) Object.prototype.hasOwnProperty.call(e, o) && t.indexOf(o) < 0 && (n[o] = e[o]);
              if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
                var r = 0;
                for (o = Object.getOwnPropertySymbols(e); r < o.length; r++) t.indexOf(o[r]) < 0 && Object.prototype.propertyIsEnumerable.call(e, o[r]) && (n[o[r]] = e[o[r]]);
              }
              return n;
            };
          Object.defineProperty(t, "__esModule", {
            value: !0
          }), t.Widget = void 0;
          var u = a(n(156)),
            c = n(611),
            l = n(794);
          t.Widget = function (e) {
            var t = e.id,
              n = e.style,
              r = void 0 === n ? {} : n,
              i = e.className,
              a = void 0 === i ? "" : i,
              d = s(e, ["id", "style", "className"]),
              f = (0, u.useRef)(null);
            return (0, u.useEffect)(function () {
              if (f.current) {
                var e = (0, c.createWidget)(t, o(o({}, d), {
                  container: f.current
                }));
                return function () {
                  e.unmount();
                };
              }
            }, [t, d]), u.default.createElement(u.default.Fragment, null, u.default.createElement(l.InlineStyle, {
              filename: "widget"
            }), u.default.createElement("div", {
              style: r,
              className: a,
              ref: f
            }));
          };
        },
        797: function (e, t, n) {
          "use strict";

          var o = this && this.__createBinding || (Object.create ? function (e, t, n, o) {
              void 0 === o && (o = n);
              var r = Object.getOwnPropertyDescriptor(t, n);
              r && !("get" in r ? !t.__esModule : r.writable || r.configurable) || (r = {
                enumerable: !0,
                get: function () {
                  return t[n];
                }
              }), Object.defineProperty(e, o, r);
            } : function (e, t, n, o) {
              void 0 === o && (o = n), e[o] = t[n];
            }),
            r = this && this.__exportStar || function (e, t) {
              for (var n in e) "default" === n || Object.prototype.hasOwnProperty.call(t, n) || o(t, e, n);
            };
          Object.defineProperty(t, "__esModule", {
            value: !0
          }), r(n(553), t);
        },
        553: function (e, t, n) {
          "use strict";

          var o = this && this.__importDefault || function (e) {
            return e && e.__esModule ? e : {
              default: e
            };
          };
          Object.defineProperty(t, "__esModule", {
            value: !0
          }), t.memoComponent = t.propsAreEqual = void 0;
          var r = n(156),
            i = o(n(378));
          t.propsAreEqual = function (e, t) {
            return (0, i.default)(e, t);
          }, t.memoComponent = function (e) {
            return (0, r.memo)(e, t.propsAreEqual);
          };
        },
        52: function (e, t, n) {
          "use strict";

          Object.defineProperty(t, "__esModule", {
            value: !0
          }), t.default = function () {
            return void 0 !== n.g.__webpack_nonce__ ? n.g.__webpack_nonce__ : null;
          };
        },
        367: function (e, t, n) {
          var o = {
            "./popover.css": 145,
            "./popup.css": 792,
            "./sidetab.css": 838,
            "./slider.css": 630,
            "./widget.css": 684
          };
          function r(e) {
            var t = i(e);
            return n(t);
          }
          function i(e) {
            if (!n.o(o, e)) {
              var t = new Error("Cannot find module '" + e + "'");
              throw t.code = "MODULE_NOT_FOUND", t;
            }
            return o[e];
          }
          r.keys = function () {
            return Object.keys(o);
          }, r.resolve = i, e.exports = r, r.id = 367;
        },
        611: function (e) {
          e.exports = function () {
            "use strict";

            var e = {
                8027: function (e, t) {
                  Object.defineProperty(t, "__esModule", {
                    value: !0
                  }), t.DEFAULT_DOMAIN = t.POPUP_SIZE = t.SLIDER_WIDTH = t.SLIDER_POSITION = t.LIVE_EMBED_ATTRIBUTE = t.SIDETAB_ATTRIBUTE = t.WIDGET_ATTRIBUTE = t.SLIDER_ATTRIBUTE = t.POPUP_ATTRIBUTE = t.POPOVER_ATTRIBUTE = void 0, t.POPOVER_ATTRIBUTE = "data-tf-popover", t.POPUP_ATTRIBUTE = "data-tf-popup", t.SLIDER_ATTRIBUTE = "data-tf-slider", t.WIDGET_ATTRIBUTE = "data-tf-widget", t.SIDETAB_ATTRIBUTE = "data-tf-sidetab", t.LIVE_EMBED_ATTRIBUTE = "data-tf-live", t.SLIDER_POSITION = "right", t.SLIDER_WIDTH = 800, t.POPUP_SIZE = 100, t.DEFAULT_DOMAIN = "form.typeform.com";
                },
                7528: function (e, t, n) {
                  var o = this && this.__assign || function () {
                      return o = Object.assign || function (e) {
                        for (var t, n = 1, o = arguments.length; n < o; n++) for (var r in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
                        return e;
                      }, o.apply(this, arguments);
                    },
                    r = this && this.__rest || function (e, t) {
                      var n = {};
                      for (var o in e) Object.prototype.hasOwnProperty.call(e, o) && t.indexOf(o) < 0 && (n[o] = e[o]);
                      if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
                        var r = 0;
                        for (o = Object.getOwnPropertySymbols(e); r < o.length; r++) t.indexOf(o[r]) < 0 && Object.prototype.propertyIsEnumerable.call(e, o[r]) && (n[o[r]] = e[o[r]]);
                      }
                      return n;
                    };
                  Object.defineProperty(t, "__esModule", {
                    value: !0
                  }), t.createPopover = void 0;
                  var i = n(6797),
                    a = n(1320),
                    s = function (e, t) {
                      var n = e.parentNode;
                      n && (n.removeChild(e), n.appendChild(t));
                    },
                    u = function (e, t) {
                      void 0 === e && (e = "span"), void 0 === t && (t = "tf-v1-popover-button-icon");
                      var n = document.createElement(e);
                      return n.className = "".concat(t, " tf-v1-close-icon"), n.innerHTML = "&times;", n.dataset.testid = t, n;
                    },
                    c = {
                      buttonColor: "#3a7685"
                    };
                  t.createPopover = function (e, t) {
                    void 0 === t && (t = {});
                    var n,
                      l,
                      d,
                      f = o(o({}, c), t),
                      p = f.domain,
                      v = r(f, ["domain"]),
                      m = (0, i.createIframe)("popover", {
                        formId: e,
                        domain: p,
                        options: v
                      }),
                      h = m.iframe,
                      b = m.embedId,
                      g = m.refresh,
                      y = m.focus,
                      w = function (e, t) {
                        var n = document.createElement("div");
                        return n.className = "tf-v1-popover", n.dataset.testid = "tf-v1-popover", (0, i.setElementSize)(n, {
                          width: e,
                          height: t
                        });
                      }(v.width, v.height),
                      x = function () {
                        var e = document.createElement("div");
                        return e.className = "tf-v1-popover-wrapper", e.dataset.testid = "tf-v1-popover-wrapper", e;
                      }(),
                      O = function (e, t) {
                        var n = (0, i.getTextColor)(t),
                          o = document.createElement("div");
                        o.className = "tf-v1-popover-button-icon";
                        var r = '<svg class="default" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\n    <path d="M21 0H0V9L10.5743 24V16.5H21C22.6567 16.5 24 15.1567 24 13.5V3C24 1.34325 22.6567 0 21 0ZM7.5\n    9.75C6.672 9.75 6 9.07875 6 8.25C6 7.42125 6.672 6.75 7.5 6.75C8.328 6.75 9 7.42125 9 8.25C9 9.07875 8.328 9.75\n    7.5 9.75ZM12.75 9.75C11.922 9.75 11.25 9.07875 11.25 8.25C11.25 7.42125 11.922 6.75 12.75 6.75C13.578 6.75 14.25\n    7.42125 14.25 8.25C14.25 9.07875 13.578 9.75 12.75 9.75ZM18 9.75C17.172 9.75 16.5 9.07875 16.5 8.25C16.5 7.42125\n    17.172 6.75 18 6.75C18.828 6.75 19.5 7.42125 19.5 8.25C19.5 9.07875 18.828 9.75 18 9.75Z" fill="'.concat(n, '"></path>\n  </svg>'),
                          a = null == e ? void 0 : e.startsWith("http");
                        return o.innerHTML = a ? "<img alt='popover trigger icon button' src='".concat(e, "'/>") : null != e ? e : r, o.dataset.testid = "default-icon", o;
                      }(v.customIcon, v.buttonColor || c.buttonColor),
                      _ = function () {
                        var e = document.createElement("div");
                        e.className = "tf-v1-spinner";
                        var t = document.createElement("div");
                        return t.className = "tf-v1-popover-button-icon", t.dataset.testid = "spinner-icon", t.append(e), t;
                      }(),
                      j = u(),
                      P = u("button", "tf-v1-popover-close"),
                      E = function (e, t) {
                        void 0 === t && (t = {});
                        var n = (0, i.getTextColor)(e),
                          o = document.createElement("button");
                        return o.className = "tf-v1-popover-button", o.dataset.testid = "tf-v1-popover-button", o.style.backgroundColor = e, o.style.color = n, (0, i.addAttributesToElement)(o, t), o;
                      }(v.buttonColor || c.buttonColor, v.buttonProps);
                    (v.container || document.body).append(w), x.append(h), w.append(E), w.append(P), E.append(O);
                    var S = function () {
                      l && l.parentNode && (l.classList.add("closing"), setTimeout(function () {
                        (0, i.unmountElement)(l);
                      }, 250));
                    };
                    v.tooltip && v.tooltip.length > 0 && (l = function (e, t) {
                      var n = document.createElement("span");
                      n.className = "tf-v1-popover-tooltip-close", n.dataset.testid = "tf-v1-popover-tooltip-close", n.innerHTML = "&times;", n.onclick = t;
                      var o = document.createElement("div");
                      o.className = "tf-v1-popover-tooltip-text", o.innerHTML = e;
                      var r = document.createElement("div");
                      return r.className = "tf-v1-popover-tooltip", r.dataset.testid = "tf-v1-popover-tooltip", r.appendChild(o), r.appendChild(n), r;
                    }(v.tooltip, S), w.append(l)), v.notificationDays && (v.enableSandbox || (0, a.canBuildNotificationDot)(e)) && (d = (0, a.buildNotificationDot)(), E.append(d)), h.onload = function () {
                      w.classList.add("open"), x.style.opacity = "1", P.style.opacity = "1", s(_, j), (0, i.addCustomKeyboardListener)(I);
                    };
                    var C = function () {
                        (0, i.isOpen)(x) || (S(), d && (d.classList.add("closing"), v.notificationDays && !v.enableSandbox && (0, a.saveNotificationDotHideUntilTime)(e, v.notificationDays), setTimeout(function () {
                          (0, i.unmountElement)(d);
                        }, 250)), setTimeout(function () {
                          (0, i.isInPage)(x) ? (x.style.opacity = "0", P.style.opacity = "0", x.style.display = "flex", setTimeout(function () {
                            w.classList.add("open"), x.style.opacity = "1", P.style.opacity = "1";
                          }), s(O, j)) : (w.append(x), s(O, _), x.style.opacity = "0", P.style.opacity = "0");
                        }));
                      },
                      I = function () {
                        var e;
                        (0, i.isOpen)(w) && (null === (e = t.onClose) || void 0 === e || e.call(t), setTimeout(function () {
                          v.keepSession ? x.style.display = "none" : (0, i.unmountElement)(x), w.classList.remove("open"), s(j, O);
                        }, 250));
                      };
                    (0, i.setAutoClose)(b, v.autoClose, I);
                    var T = function () {
                      (0, i.isOpen)(x) ? I() : C();
                    };
                    return E.onclick = (0, i.invokeWithoutDefault)(T), P.onclick = (0, i.invokeWithoutDefault)(I), v.open && !(0, i.isOpen)(x) && (n = (0, i.handleCustomOpen)(C, v.open, v.openValue)), {
                      open: C,
                      close: I,
                      toggle: T,
                      refresh: g,
                      focus: y,
                      unmount: function () {
                        (0, i.unmountElement)(w), v.open && (null == n ? void 0 : n.remove) && n.remove();
                      }
                    };
                  };
                },
                1797: function (e, t, n) {
                  var o = this && this.__createBinding || (Object.create ? function (e, t, n, o) {
                      void 0 === o && (o = n);
                      var r = Object.getOwnPropertyDescriptor(t, n);
                      r && !("get" in r ? !t.__esModule : r.writable || r.configurable) || (r = {
                        enumerable: !0,
                        get: function () {
                          return t[n];
                        }
                      }), Object.defineProperty(e, o, r);
                    } : function (e, t, n, o) {
                      void 0 === o && (o = n), e[o] = t[n];
                    }),
                    r = this && this.__exportStar || function (e, t) {
                      for (var n in e) "default" === n || Object.prototype.hasOwnProperty.call(t, n) || o(t, e, n);
                    };
                  Object.defineProperty(t, "__esModule", {
                    value: !0
                  }), r(n(7528), t), r(n(6100), t);
                },
                1320: function (e, t) {
                  var n = this && this.__assign || function () {
                    return n = Object.assign || function (e) {
                      for (var t, n = 1, o = arguments.length; n < o; n++) for (var r in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
                      return e;
                    }, n.apply(this, arguments);
                  };
                  Object.defineProperty(t, "__esModule", {
                    value: !0
                  }), t.buildNotificationDot = t.canBuildNotificationDot = t.saveNotificationDotHideUntilTime = void 0;
                  var o = "tfNotificationData",
                    r = function () {
                      var e = localStorage.getItem(o);
                      return e ? JSON.parse(e) : {};
                    },
                    i = function (e) {
                      e && localStorage.setItem(o, JSON.stringify(e));
                    };
                  t.saveNotificationDotHideUntilTime = function (e, t) {
                    var o,
                      a = new Date();
                    a.setDate(a.getDate() + t), i(n(n({}, r()), ((o = {})[e] = {
                      hideUntilTime: a.getTime()
                    }, o)));
                  }, t.canBuildNotificationDot = function (e) {
                    var t = function (e) {
                      var t;
                      return (null === (t = r()[e]) || void 0 === t ? void 0 : t.hideUntilTime) || 0;
                    }(e);
                    return new Date().getTime() > t && (t && function (e) {
                      var t = r();
                      delete t[e], i(t);
                    }(e), !0);
                  }, t.buildNotificationDot = function () {
                    var e = document.createElement("span");
                    return e.className = "tf-v1-popover-unread-dot", e.dataset.testid = "tf-v1-popover-unread-dot", e;
                  };
                },
                6100: function (e, t) {
                  Object.defineProperty(t, "__esModule", {
                    value: !0
                  });
                },
                9630: function (e, t, n) {
                  var o = this && this.__rest || function (e, t) {
                    var n = {};
                    for (var o in e) Object.prototype.hasOwnProperty.call(e, o) && t.indexOf(o) < 0 && (n[o] = e[o]);
                    if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
                      var r = 0;
                      for (o = Object.getOwnPropertySymbols(e); r < o.length; r++) t.indexOf(o[r]) < 0 && Object.prototype.propertyIsEnumerable.call(e, o[r]) && (n[o[r]] = e[o[r]]);
                    }
                    return n;
                  };
                  Object.defineProperty(t, "__esModule", {
                    value: !0
                  }), t.createPopup = void 0;
                  var r = n(6797),
                    i = n(8027),
                    a = n(6797);
                  t.createPopup = function (e, t) {
                    if (void 0 === t && (t = {}), !(0, r.hasDom)()) return {
                      open: function () {},
                      close: function () {},
                      toggle: function () {},
                      refresh: function () {},
                      focus: function () {},
                      unmount: function () {}
                    };
                    var n,
                      s = t.width,
                      u = t.height,
                      c = t.size,
                      l = void 0 === c ? i.POPUP_SIZE : c,
                      d = t.onClose,
                      f = t.domain,
                      p = o(t, ["width", "height", "size", "onClose", "domain"]),
                      v = (0, r.createIframe)("popup", {
                        formId: e,
                        domain: f,
                        options: p
                      }),
                      m = v.iframe,
                      h = v.embedId,
                      b = v.refresh,
                      g = v.focus,
                      y = document.body.style.overflow,
                      w = function () {
                        var e = document.createElement("div");
                        return e.className = "tf-v1-popup", e.dataset.testid = "tf-v1-popup", e.style.opacity = "0", e;
                      }(),
                      x = function () {
                        var e = document.createElement("div");
                        return e.className = "tf-v1-spinner", e;
                      }(),
                      O = function (e, t, n) {
                        var o = document.createElement("div");
                        return o.className = "tf-v1-iframe-wrapper", o.style.opacity = "0", (0, r.isDefined)(e) && (0, r.isDefined)(t) ? (0, r.setElementSize)(o, {
                          width: e,
                          height: t
                        }) : (o.style.width = "calc(".concat(n, "% - 80px)"), o.style.height = "calc(".concat(n, "% - 80px)"), o);
                      }(s, u, l);
                    O.append(m), w.append(x), w.append(O);
                    var _ = p.container || document.body;
                    m.onload = function () {
                      O.style.opacity = "1", setTimeout(function () {
                        x.style.display = "none";
                      }, 250), (0, r.addCustomKeyboardListener)(P);
                    };
                    var j = function () {
                        (0, a.isOpen)(w) || ((0, a.isInPage)(w) ? w.style.display = "flex" : (x.style.display = "block", _.append(w)), document.body.style.overflow = "hidden", setTimeout(function () {
                          w.style.opacity = "1";
                        }));
                      },
                      P = function () {
                        (0, a.isOpen)(w) && (null == d || d(), w.style.opacity = "0", document.body.style.overflow = y, setTimeout(function () {
                          p.keepSession ? w.style.display = "none" : E();
                        }, 250));
                      };
                    O.append(function (e) {
                      var t = document.createElement("button");
                      return t.className = "tf-v1-close tf-v1-close-icon", t.innerHTML = "&times;", t.onclick = (0, r.invokeWithoutDefault)(e), t;
                    }(P)), (0, r.setAutoClose)(h, p.autoClose, P), p.open && !(0, a.isOpen)(w) && (n = (0, r.handleCustomOpen)(j, p.open, p.openValue));
                    var E = function () {
                      (0, r.unmountElement)(w), p.open && (null == n ? void 0 : n.remove) && n.remove();
                    };
                    return {
                      open: j,
                      close: P,
                      toggle: function () {
                        (0, a.isOpen)(w) ? P() : j();
                      },
                      refresh: b,
                      focus: g,
                      unmount: E
                    };
                  };
                },
                5970: function (e, t, n) {
                  var o = this && this.__createBinding || (Object.create ? function (e, t, n, o) {
                      void 0 === o && (o = n);
                      var r = Object.getOwnPropertyDescriptor(t, n);
                      r && !("get" in r ? !t.__esModule : r.writable || r.configurable) || (r = {
                        enumerable: !0,
                        get: function () {
                          return t[n];
                        }
                      }), Object.defineProperty(e, o, r);
                    } : function (e, t, n, o) {
                      void 0 === o && (o = n), e[o] = t[n];
                    }),
                    r = this && this.__exportStar || function (e, t) {
                      for (var n in e) "default" === n || Object.prototype.hasOwnProperty.call(t, n) || o(t, e, n);
                    };
                  Object.defineProperty(t, "__esModule", {
                    value: !0
                  }), r(n(9630), t), r(n(7394), t);
                },
                7394: function (e, t) {
                  Object.defineProperty(t, "__esModule", {
                    value: !0
                  });
                },
                382: function (e, t, n) {
                  var o = this && this.__assign || function () {
                      return o = Object.assign || function (e) {
                        for (var t, n = 1, o = arguments.length; n < o; n++) for (var r in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
                        return e;
                      }, o.apply(this, arguments);
                    },
                    r = this && this.__rest || function (e, t) {
                      var n = {};
                      for (var o in e) Object.prototype.hasOwnProperty.call(e, o) && t.indexOf(o) < 0 && (n[o] = e[o]);
                      if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
                        var r = 0;
                        for (o = Object.getOwnPropertySymbols(e); r < o.length; r++) t.indexOf(o[r]) < 0 && Object.prototype.propertyIsEnumerable.call(e, o[r]) && (n[o[r]] = e[o[r]]);
                      }
                      return n;
                    };
                  Object.defineProperty(t, "__esModule", {
                    value: !0
                  }), t.createSidetab = void 0;
                  var i = n(6797),
                    a = {
                      buttonColor: "#3a7685",
                      buttonText: "Launch me"
                    },
                    s = function (e, t) {
                      void 0 === e && (e = "div"), void 0 === t && (t = "tf-v1-sidetab-button-icon");
                      var n = document.createElement(e);
                      return n.className = "".concat(t, " tf-v1-close-icon"), n.innerHTML = "&times;", n.dataset.testid = t, n;
                    },
                    u = function (e, t) {
                      var n = e.parentNode;
                      n && (n.removeChild(e), n.appendChild(t));
                    };
                  t.createSidetab = function (e, t) {
                    void 0 === t && (t = {});
                    var n,
                      c = o(o({}, a), t),
                      l = c.domain,
                      d = r(c, ["domain"]),
                      f = (0, i.createIframe)("side-tab", {
                        formId: e,
                        domain: l,
                        options: d
                      }),
                      p = f.iframe,
                      v = f.embedId,
                      m = f.refresh,
                      h = f.focus,
                      b = function (e, t, n, o) {
                        var r = document.createElement("div");
                        return r.className = "tf-v1-sidetab", r.dataset.testid = "tf-v1-sidetab", (0, i.setElementSize)(r, {
                          width: e,
                          height: t
                        }), void 0 !== n ? (r.style.top = "calc(".concat((0, i.getValueWithUnits)(n), " + ").concat((0, i.getValueWithUnits)(t || 580), " / 2)"), r.style.bottom = "auto") : void 0 !== o && (r.style.top = "auto", r.style.bottom = "calc(".concat((0, i.getValueWithUnits)(o), " - ").concat((0, i.getValueWithUnits)(t || 580), " / 2)")), r;
                      }(d.width, d.height, d.top, d.bottom),
                      g = function () {
                        var e = document.createElement("div");
                        return e.className = "tf-v1-sidetab-wrapper", e.dataset.testid = "tf-v1-sidetab-wrapper", e;
                      }(),
                      y = function () {
                        var e = document.createElement("div");
                        e.className = "tf-v1-spinner";
                        var t = document.createElement("div");
                        return t.className = "tf-v1-sidetab-button-icon", t.dataset.testid = "spinner-icon", t.append(e), t;
                      }(),
                      w = function (e) {
                        var t = e.backgroundColor,
                          n = e.textColor,
                          o = e.width,
                          r = e.height,
                          a = e.align,
                          s = void 0 === a ? "center" : a,
                          u = e.buttonProps,
                          c = void 0 === u ? {} : u,
                          l = document.createElement("button");
                        return l.className = "tf-v1-sidetab-button", l.style.backgroundColor = t, l.style.color = n || (0, i.getTextColor)(t), (0, i.addAttributesToElement)(l, c), (0, i.setElementSize)(l, {
                          width: o,
                          height: r
                        }), r && (l.style.left = "-".concat((0, i.getValueWithUnits)(r))), "top" === s ? (l.style.transform = "rotate(-90deg) translateX(-100%)", l.style.top = "0") : "bottom" === s && (l.style.transform = "rotate(-90deg) translateX(0)", l.style.top = "auto", l.style.bottom = "-".concat((0, i.getValueWithUnits)(r || 48))), l;
                      }({
                        backgroundColor: d.buttonColor || a.buttonColor,
                        textColor: d.buttonTextColor,
                        width: d.buttonHeight,
                        height: d.buttonWidth,
                        align: d.buttonAlign,
                        buttonProps: d.buttonProps
                      }),
                      x = function (e, t) {
                        var n = document.createElement("span");
                        return n.className = "tf-v1-sidetab-button-text", n.innerHTML = e, t && (n.style.fontSize = (0, i.getValueWithUnits)(t)), n;
                      }(d.buttonText || a.buttonText, d.buttonTextSize),
                      O = function (e, t, n, o) {
                        var r = n || (0, i.getTextColor)(t),
                          a = document.createElement("div");
                        a.className = "tf-v1-sidetab-button-icon", o && (a.style.width = (0, i.getValueWithUnits)(o), a.style.height = (0, i.getValueWithUnits)(o));
                        var s = '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\n    <path d="M21 0H0V9L10.5743 24V16.5H21C22.6567 16.5 24 15.1567 24 13.5V3C24 1.34325 22.6567 0 21 0ZM7.5 9.75C6.672 9.75 6 9.07875 6 8.25C6 7.42125 6.672 6.75 7.5 6.75C8.328 6.75 9 7.42125 9 8.25C9 9.07875 8.328 9.75 7.5 9.75ZM12.75 9.75C11.922 9.75 11.25 9.07875 11.25 8.25C11.25 7.42125 11.922 6.75 12.75 6.75C13.578 6.75 14.25 7.42125 14.25 8.25C14.25 9.07875 13.578 9.75 12.75 9.75ZM18 9.75C17.172 9.75 16.5 9.07875 16.5 8.25C16.5 7.42125 17.172 6.75 18 6.75C18.828 6.75 19.5 7.42125 19.5 8.25C19.5 9.07875 18.828 9.75 18 9.75Z" fill="'.concat(r, '"></path>\n  </svg>'),
                          u = null == e ? void 0 : e.startsWith("http");
                        return a.innerHTML = u ? "<img alt='popover trigger icon button' src='".concat(e, "'/>") : null != e ? e : s, a.dataset.testid = "default-icon", a;
                      }(d.customIcon, d.buttonColor || a.buttonColor, d.buttonTextColor, d.buttonTextSize),
                      _ = s(),
                      j = s("button", "tf-v1-sidetab-close");
                    (d.container || document.body).append(b), g.append(p), b.append(w), b.append(j), w.append(O), w.append(x), setTimeout(function () {
                      b.classList.add("ready");
                    }, 250), p.onload = function () {
                      b.classList.add("open"), u(y, _), (0, i.addCustomKeyboardListener)(E);
                    };
                    var P = function () {
                        (0, i.isOpen)(g) || ((0, i.isInPage)(g) ? (g.style.display = "flex", b.classList.add("open"), u(O, _)) : (b.append(g), u(O, y)));
                      },
                      E = function () {
                        var e;
                        (0, i.isOpen)(g) && (null === (e = d.onClose) || void 0 === e || e.call(d), b.classList.remove("open"), setTimeout(function () {
                          d.keepSession ? g.style.display = "none" : (0, i.unmountElement)(g), u(_, O);
                        }, 250));
                      };
                    (0, i.setAutoClose)(v, d.autoClose, E);
                    var S = function () {
                      (0, i.isOpen)(g) ? E() : P();
                    };
                    return w.onclick = (0, i.invokeWithoutDefault)(S), j.onclick = (0, i.invokeWithoutDefault)(E), d.open && !(0, i.isOpen)(g) && (n = (0, i.handleCustomOpen)(P, d.open, d.openValue)), {
                      open: P,
                      close: E,
                      toggle: S,
                      refresh: m,
                      focus: h,
                      unmount: function () {
                        (0, i.unmountElement)(b), d.open && (null == n ? void 0 : n.remove) && n.remove();
                      }
                    };
                  };
                },
                1434: function (e, t, n) {
                  var o = this && this.__createBinding || (Object.create ? function (e, t, n, o) {
                      void 0 === o && (o = n);
                      var r = Object.getOwnPropertyDescriptor(t, n);
                      r && !("get" in r ? !t.__esModule : r.writable || r.configurable) || (r = {
                        enumerable: !0,
                        get: function () {
                          return t[n];
                        }
                      }), Object.defineProperty(e, o, r);
                    } : function (e, t, n, o) {
                      void 0 === o && (o = n), e[o] = t[n];
                    }),
                    r = this && this.__exportStar || function (e, t) {
                      for (var n in e) "default" === n || Object.prototype.hasOwnProperty.call(t, n) || o(t, e, n);
                    };
                  Object.defineProperty(t, "__esModule", {
                    value: !0
                  }), r(n(382), t), r(n(7668), t);
                },
                7668: function (e, t) {
                  Object.defineProperty(t, "__esModule", {
                    value: !0
                  });
                },
                2603: function (e, t, n) {
                  var o = this && this.__rest || function (e, t) {
                    var n = {};
                    for (var o in e) Object.prototype.hasOwnProperty.call(e, o) && t.indexOf(o) < 0 && (n[o] = e[o]);
                    if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
                      var r = 0;
                      for (o = Object.getOwnPropertySymbols(e); r < o.length; r++) t.indexOf(o[r]) < 0 && Object.prototype.propertyIsEnumerable.call(e, o[r]) && (n[o[r]] = e[o[r]]);
                    }
                    return n;
                  };
                  Object.defineProperty(t, "__esModule", {
                    value: !0
                  }), t.createSlider = void 0;
                  var r = n(6797),
                    i = n(8027);
                  t.createSlider = function (e, t) {
                    if (void 0 === t && (t = {}), !(0, r.hasDom)()) return {
                      open: function () {},
                      close: function () {},
                      toggle: function () {},
                      refresh: function () {},
                      focus: function () {},
                      unmount: function () {}
                    };
                    var n,
                      a = t.position,
                      s = void 0 === a ? i.SLIDER_POSITION : a,
                      u = t.width,
                      c = void 0 === u ? i.SLIDER_WIDTH : u,
                      l = t.onClose,
                      d = t.domain,
                      f = o(t, ["position", "width", "onClose", "domain"]),
                      p = (0, r.createIframe)("slider", {
                        formId: e,
                        domain: d,
                        options: f
                      }),
                      v = p.iframe,
                      m = p.embedId,
                      h = p.refresh,
                      b = p.focus,
                      g = document.body.style.overflow,
                      y = function (e) {
                        var t = document.createElement("div");
                        return t.className = "tf-v1-slider ".concat(e), t.dataset.testid = "tf-v1-slider", t.style.opacity = "0", t;
                      }(s),
                      w = function () {
                        var e = document.createElement("div");
                        return e.className = "tf-v1-spinner", e;
                      }(),
                      x = function (e, t) {
                        var n = document.createElement("div");
                        return n.className = "tf-v1-iframe-wrapper", n.style[e] = "-100%", (0, r.setElementSize)(n, {
                          width: t
                        });
                      }(s, c);
                    x.append(v), y.append(w), y.append(x);
                    var O = f.container || document.body;
                    v.onload = function () {
                      x.style[s] = "0", setTimeout(function () {
                        w.style.display = "none";
                      }, 500), (0, r.addCustomKeyboardListener)(j);
                    };
                    var _ = function () {
                        (0, r.isOpen)(y) || ((0, r.isInPage)(y) ? (y.style.display = "flex", setTimeout(function () {
                          x.style[s] = "0";
                        })) : (O.append(y), w.style.display = "block"), document.body.style.overflow = "hidden", setTimeout(function () {
                          y.style.opacity = "1";
                        }));
                      },
                      j = function () {
                        (0, r.isOpen)(y) && (null == l || l(), y.style.opacity = "0", x.style[s] = "-100%", document.body.style.overflow = g, setTimeout(function () {
                          f.keepSession ? y.style.display = "none" : P();
                        }, 500));
                      };
                    (0, r.setAutoClose)(m, f.autoClose, j), x.append(function (e) {
                      var t = document.createElement("button");
                      return t.className = "tf-v1-close tf-v1-close-icon", t.innerHTML = "&times;", t.onclick = (0, r.invokeWithoutDefault)(e), t;
                    }(j)), f.open && !(0, r.isOpen)(y) && (n = (0, r.handleCustomOpen)(_, f.open, f.openValue));
                    var P = function () {
                      (0, r.unmountElement)(y), f.open && (null == n ? void 0 : n.remove) && n.remove();
                    };
                    return {
                      open: _,
                      close: j,
                      toggle: function () {
                        (0, r.isOpen)(y) ? j() : _();
                      },
                      refresh: h,
                      focus: b,
                      unmount: P
                    };
                  };
                },
                4071: function (e, t, n) {
                  var o = this && this.__createBinding || (Object.create ? function (e, t, n, o) {
                      void 0 === o && (o = n);
                      var r = Object.getOwnPropertyDescriptor(t, n);
                      r && !("get" in r ? !t.__esModule : r.writable || r.configurable) || (r = {
                        enumerable: !0,
                        get: function () {
                          return t[n];
                        }
                      }), Object.defineProperty(e, o, r);
                    } : function (e, t, n, o) {
                      void 0 === o && (o = n), e[o] = t[n];
                    }),
                    r = this && this.__exportStar || function (e, t) {
                      for (var n in e) "default" === n || Object.prototype.hasOwnProperty.call(t, n) || o(t, e, n);
                    };
                  Object.defineProperty(t, "__esModule", {
                    value: !0
                  }), r(n(2603), t), r(n(3162), t);
                },
                3162: function (e, t) {
                  Object.defineProperty(t, "__esModule", {
                    value: !0
                  });
                },
                718: function (e, t, n) {
                  var o = this && this.__rest || function (e, t) {
                      var n = {};
                      for (var o in e) Object.prototype.hasOwnProperty.call(e, o) && t.indexOf(o) < 0 && (n[o] = e[o]);
                      if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
                        var r = 0;
                        for (o = Object.getOwnPropertySymbols(e); r < o.length; r++) t.indexOf(o[r]) < 0 && Object.prototype.propertyIsEnumerable.call(e, o[r]) && (n[o[r]] = e[o[r]]);
                      }
                      return n;
                    },
                    r = this && this.__read || function (e, t) {
                      var n = "function" == typeof Symbol && e[Symbol.iterator];
                      if (!n) return e;
                      var o,
                        r,
                        i = n.call(e),
                        a = [];
                      try {
                        for (; (void 0 === t || t-- > 0) && !(o = i.next()).done;) a.push(o.value);
                      } catch (e) {
                        r = {
                          error: e
                        };
                      } finally {
                        try {
                          o && !o.done && (n = i.return) && n.call(i);
                        } finally {
                          if (r) throw r.error;
                        }
                      }
                      return a;
                    };
                  Object.defineProperty(t, "__esModule", {
                    value: !0
                  }), t.createWidget = void 0;
                  var i = n(6797),
                    a = n(8554),
                    s = n(2313),
                    u = n(1126);
                  t.createWidget = function (e, t) {
                    if (!(0, i.hasDom)()) return {
                      refresh: function () {},
                      focus: function () {},
                      unmount: function () {}
                    };
                    var n = t.domain,
                      c = o(t, ["domain"]);
                    c.inlineOnMobile = t.inlineOnMobile || t.fullScreen, c.inlineOnMobile || !c.forceTouch && !(0, i.isFullscreen)() || (c.displayAsFullScreenModal = !0, c.forceTouch = !0);
                    var l = (0, i.createIframe)("widget", {
                        formId: e,
                        domain: n,
                        options: c
                      }),
                      d = l.embedId,
                      f = l.iframe,
                      p = l.refresh,
                      v = l.focus,
                      m = (0, s.buildWidget)(f, c.width, c.height);
                    if (c.fullScreen && (0, u.overrideFullScreenStyles)(t.container, f), c.autoResize) {
                      var h = r("string" == typeof c.autoResize ? c.autoResize.split(",").map(function (e) {
                          return parseInt(e);
                        }) : [], 2),
                        b = h[0],
                        g = h[1];
                      window.addEventListener("message", (0, a.getFormHeightChangedHandler)(d, function (e) {
                        var n = Math.max(e.height, b || 0);
                        g && (n = Math.min(n, g)), t.container.style.height = "".concat(n, "px");
                      }));
                    }
                    c.autoFocus && window.addEventListener("message", (0, a.getFormReadyHandler)(d, function () {
                      setTimeout(function () {
                        v();
                      }, 1e3);
                    }));
                    var y,
                      w = function () {
                        return t.container.append(m);
                      };
                    if (t.container.innerHTML = "", t.lazy ? (0, i.lazyInitialize)(t.container, w) : w(), c.displayAsFullScreenModal) {
                      var x = "",
                        O = t.container,
                        _ = O.style.height;
                      window.addEventListener("message", (0, a.getWelcomeScreenHiddenHandler)(d, function () {
                        O.classList.add("tf-v1-widget-fullscreen"), void 0 !== t.opacity && (O.style.backgroundColor = x);
                      })), window.addEventListener("message", (0, a.getFormThemeHandler)(d, function (e) {
                        var t;
                        x = (0, i.changeColorOpacity)(null === (t = null == e ? void 0 : e.theme) || void 0 === t ? void 0 : t.backgroundColor);
                      }));
                      var j = ((y = document.createElement("button")).className = "tf-v1-widget-close tf-v1-close-icon", y.innerHTML = "&times;", y);
                      j.onclick = (0, i.invokeWithoutDefault)(function () {
                        var e;
                        if (O.style.height = _, null === (e = t.onClose) || void 0 === e || e.call(t), O.classList.remove("tf-v1-widget-fullscreen"), O.style.backgroundColor = "", t.keepSession) {
                          var n = document.createElement("div");
                          n.className = "tf-v1-widget-iframe-overlay", n.onclick = function () {
                            O.classList.add("tf-v1-widget-fullscreen"), (0, i.unmountElement)(n);
                          }, m.append(n);
                        } else t.container.innerHTML = "", w(), O.append(j);
                      }), O.append(j);
                    }
                    return {
                      refresh: p,
                      focus: v,
                      unmount: function () {
                        (0, i.unmountElement)(m);
                      }
                    };
                  };
                },
                1419: function (e, t, n) {
                  Object.defineProperty(t, "__esModule", {
                    value: !0
                  }), t.buildWidget = void 0;
                  var o = n(6797);
                  t.buildWidget = function (e, t, n) {
                    var r = document.createElement("div");
                    return r.className = "tf-v1-widget", r.dataset.testid = "tf-v1-widget", r.append(e), (0, o.setElementSize)(r, {
                      width: t,
                      height: n
                    });
                  };
                },
                2313: function (e, t, n) {
                  var o = this && this.__createBinding || (Object.create ? function (e, t, n, o) {
                      void 0 === o && (o = n);
                      var r = Object.getOwnPropertyDescriptor(t, n);
                      r && !("get" in r ? !t.__esModule : r.writable || r.configurable) || (r = {
                        enumerable: !0,
                        get: function () {
                          return t[n];
                        }
                      }), Object.defineProperty(e, o, r);
                    } : function (e, t, n, o) {
                      void 0 === o && (o = n), e[o] = t[n];
                    }),
                    r = this && this.__exportStar || function (e, t) {
                      for (var n in e) "default" === n || Object.prototype.hasOwnProperty.call(t, n) || o(t, e, n);
                    };
                  Object.defineProperty(t, "__esModule", {
                    value: !0
                  }), r(n(1419), t);
                },
                1126: function (e, t) {
                  Object.defineProperty(t, "__esModule", {
                    value: !0
                  }), t.overrideFullScreenStyles = void 0, t.overrideFullScreenStyles = function (e, t) {
                    Object.assign(e.style, {
                      zIndex: "10001",
                      position: "absolute",
                      top: "0",
                      left: "0",
                      width: "100%",
                      height: "100%"
                    }), t.style.borderRadius = "0", Object.assign(document.body.style, {
                      overflow: "hidden"
                    });
                  };
                },
                9321: function (e, t, n) {
                  var o = this && this.__createBinding || (Object.create ? function (e, t, n, o) {
                      void 0 === o && (o = n);
                      var r = Object.getOwnPropertyDescriptor(t, n);
                      r && !("get" in r ? !t.__esModule : r.writable || r.configurable) || (r = {
                        enumerable: !0,
                        get: function () {
                          return t[n];
                        }
                      }), Object.defineProperty(e, o, r);
                    } : function (e, t, n, o) {
                      void 0 === o && (o = n), e[o] = t[n];
                    }),
                    r = this && this.__exportStar || function (e, t) {
                      for (var n in e) "default" === n || Object.prototype.hasOwnProperty.call(t, n) || o(t, e, n);
                    };
                  Object.defineProperty(t, "__esModule", {
                    value: !0
                  }), r(n(718), t), r(n(4058), t);
                },
                4058: function (e, t) {
                  Object.defineProperty(t, "__esModule", {
                    value: !0
                  });
                },
                1920: function (e, t, n) {
                  var o = this && this.__createBinding || (Object.create ? function (e, t, n, o) {
                      void 0 === o && (o = n);
                      var r = Object.getOwnPropertyDescriptor(t, n);
                      r && !("get" in r ? !t.__esModule : r.writable || r.configurable) || (r = {
                        enumerable: !0,
                        get: function () {
                          return t[n];
                        }
                      }), Object.defineProperty(e, o, r);
                    } : function (e, t, n, o) {
                      void 0 === o && (o = n), e[o] = t[n];
                    }),
                    r = this && this.__exportStar || function (e, t) {
                      for (var n in e) "default" === n || Object.prototype.hasOwnProperty.call(t, n) || o(t, e, n);
                    };
                  Object.defineProperty(t, "__esModule", {
                    value: !0
                  }), r(n(1797), t), r(n(5970), t), r(n(4071), t), r(n(9321), t), r(n(1434), t);
                },
                5084: function (e, t, n) {
                  Object.defineProperty(t, "__esModule", {
                    value: !0
                  }), t.addAttributesToElement = void 0;
                  var o = n(7377);
                  t.addAttributesToElement = function (e, t) {
                    void 0 === t && (t = {}), Object.keys(t).forEach(function (n) {
                      e.setAttribute((0, o.camelCaseToKebabCase)(n), t[n]);
                    });
                  };
                },
                3626: function (e, t, n) {
                  var o = this && this.__assign || function () {
                      return o = Object.assign || function (e) {
                        for (var t, n = 1, o = arguments.length; n < o; n++) for (var r in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
                        return e;
                      }, o.apply(this, arguments);
                    },
                    r = this && this.__read || function (e, t) {
                      var n = "function" == typeof Symbol && e[Symbol.iterator];
                      if (!n) return e;
                      var o,
                        r,
                        i = n.call(e),
                        a = [];
                      try {
                        for (; (void 0 === t || t-- > 0) && !(o = i.next()).done;) a.push(o.value);
                      } catch (e) {
                        r = {
                          error: e
                        };
                      } finally {
                        try {
                          o && !o.done && (n = i.return) && n.call(i);
                        } finally {
                          if (r) throw r.error;
                        }
                      }
                      return a;
                    };
                  Object.defineProperty(t, "__esModule", {
                    value: !0
                  }), t.buildIframeSrc = void 0;
                  var i = n(8027),
                    a = n(4527),
                    s = n(2346),
                    u = n(2698),
                    c = n(863),
                    l = {
                      widget: "embed-widget",
                      popup: "popup-blank",
                      slider: "popup-drawer",
                      popover: "popup-popover",
                      "side-tab": "popup-side-panel"
                    };
                  t.buildIframeSrc = function (e) {
                    var t = e.domain,
                      n = e.formId,
                      d = e.type,
                      f = e.embedId,
                      p = e.options,
                      v = function (e, t, n) {
                        var r = n.transitiveSearchParams,
                          i = n.source,
                          a = n.medium,
                          s = n.mediumVersion,
                          c = n.hideFooter,
                          d = n.hideHeaders,
                          f = n.opacity,
                          p = n.disableTracking,
                          v = n.enableSandbox,
                          m = n.shareGaInstance,
                          h = n.forceTouch,
                          b = n.displayAsFullScreenModal,
                          g = n.tracking,
                          y = n.redirectTarget,
                          w = n.autoResize,
                          x = n.disableScroll,
                          O = n.onEndingButtonClick,
                          _ = n.noHeading,
                          j = (0, u.getTransitiveSearchParams)(r);
                        return o(o(o({}, {
                          "typeform-embed-id": t,
                          "typeform-embed": l[e],
                          "typeform-source": i,
                          "typeform-medium": a,
                          "typeform-medium-version": s,
                          "embed-hide-footer": c ? "true" : void 0,
                          "embed-hide-headers": d ? "true" : void 0,
                          "embed-opacity": f,
                          "disable-tracking": p || v ? "true" : void 0,
                          "__dangerous-disable-submissions": v ? "true" : void 0,
                          "share-ga-instance": m ? "true" : void 0,
                          "force-touch": h ? "true" : void 0,
                          "add-placeholder-ws": "widget" === e && b ? "true" : void 0,
                          "typeform-embed-redirect-target": y,
                          "typeform-embed-auto-resize": w ? "true" : void 0,
                          "typeform-embed-disable-scroll": x ? "true" : void 0,
                          "typeform-embed-handle-ending-button-click": O ? "true" : void 0,
                          "typeform-embed-no-heading": _ ? "true" : void 0
                        }), j), g);
                      }(d, f, function (e) {
                        return e.noHeading || (e.noHeading = document.querySelectorAll("h1").length > 0), o(o({}, {
                          source: null === (t = null === window || void 0 === window ? void 0 : window.location) || void 0 === t ? void 0 : t.hostname.replace(/^www\./, ""),
                          medium: "embed-sdk",
                          mediumVersion: "next"
                        }), (0, a.removeUndefinedKeys)(e));
                        var t;
                      }(p)),
                      m = function (e, t) {
                        return void 0 === t && (t = i.DEFAULT_DOMAIN), e.startsWith("http://") || e.startsWith("https://") ? new URL(e) : new URL("https://".concat(t, "/to/").concat(e));
                      }(n, t);
                    if (Object.entries(v).filter(function (e) {
                      var t = r(e, 2)[1];
                      return (0, s.isDefined)(t);
                    }).forEach(function (e) {
                      var t = r(e, 2),
                        n = t[0],
                        o = t[1];
                      m.searchParams.set(n, o);
                    }), p.hubspot) {
                      var h = (0, c.getHubspotHiddenFields)();
                      p.hidden = o(o({}, p.hidden), h);
                    }
                    if (p.hidden) {
                      var b = new URLSearchParams();
                      Object.entries(p.hidden).filter(function (e) {
                        var t = r(e, 2)[1];
                        return (0, s.isDefined)(t) && "" !== t;
                      }).forEach(function (e) {
                        var t = r(e, 2),
                          n = t[0],
                          o = t[1];
                        "boolean" == typeof p.transitiveSearchParams && m.searchParams.delete(n), b.set(n, o);
                      });
                      var g = b.toString();
                      g && (m.hash = g);
                    }
                    return m.href;
                  };
                },
                2391: function (e, t) {
                  Object.defineProperty(t, "__esModule", {
                    value: !0
                  }), t.changeColorOpacity = void 0, t.changeColorOpacity = function (e, t) {
                    return void 0 === e && (e = ""), void 0 === t && (t = 255), e.startsWith("rgba(") ? null == e ? void 0 : e.replace(/, [\d.]+\)$/, ", ".concat(t, ")")) : e;
                  };
                },
                8972: function (e, t) {
                  Object.defineProperty(t, "__esModule", {
                    value: !0
                  }), t.handleCustomOpen = void 0;
                  var n = {
                    remove: function () {}
                  };
                  t.handleCustomOpen = function (e, t, o) {
                    switch (t) {
                      case "load":
                        return e(), n;
                      case "exit":
                        return o ? function (e, t) {
                          var n = 0,
                            o = function (r) {
                              r.clientY < e && r.clientY < n ? (document.removeEventListener("mousemove", o, !0), t()) : n = r.clientY;
                            };
                          return document.addEventListener("mousemove", o, !0), {
                            remove: function () {
                              return document.removeEventListener("mousemove", o, !0);
                            }
                          };
                        }(o, e) : n;
                      case "time":
                        return setTimeout(function () {
                          e();
                        }, o), n;
                      case "scroll":
                        return o ? function (e, t) {
                          function n() {
                            var o = window.pageYOffset || document.documentElement.scrollTop,
                              r = document.documentElement.clientTop || 0,
                              i = document.documentElement.scrollHeight,
                              a = o - r,
                              s = a / i * 100,
                              u = a + window.innerHeight >= i;
                            (s >= e || u) && (t(), document.removeEventListener("scroll", n));
                          }
                          return document.addEventListener("scroll", n), {
                            remove: function () {
                              return document.removeEventListener("scroll", n);
                            }
                          };
                        }(o, e) : n;
                      default:
                        return n;
                    }
                  };
                },
                1553: function (e, t, n) {
                  Object.defineProperty(t, "__esModule", {
                    value: !0
                  }), t.createIframe = void 0;
                  var o = n(3626),
                    r = n(6797),
                    i = n(8866),
                    a = n(8554),
                    s = n(2256),
                    u = n(7144),
                    c = n(5511);
                  t.createIframe = function (e, t) {
                    var n = t.formId,
                      l = t.domain,
                      d = t.options,
                      f = (0, i.generateEmbedId)(),
                      p = d.iframeProps,
                      v = void 0 === p ? {} : p,
                      m = d.onReady,
                      h = d.onStarted,
                      b = d.onQuestionChanged,
                      g = d.onHeightChanged,
                      y = d.onSubmit,
                      w = d.onEndingButtonClick,
                      x = d.shareGaInstance,
                      O = (0, o.buildIframeSrc)({
                        formId: n,
                        domain: l,
                        embedId: f,
                        type: e,
                        options: d
                      }),
                      _ = document.createElement("iframe");
                    return _.src = O, _.dataset.testid = "iframe", _.style.border = "0px", _.allow = "microphone; camera", (0, r.addAttributesToElement)(_, v), _.addEventListener("load", s.triggerIframeRedraw, {
                      once: !0
                    }), window.addEventListener("message", (0, a.getFormReadyHandler)(f, m)), window.addEventListener("message", (0, a.getFormStartedHandler)(f, h)), window.addEventListener("message", (0, a.getFormQuestionChangedHandler)(f, b)), window.addEventListener("message", (0, a.getFormHeightChangedHandler)(f, g)), window.addEventListener("message", (0, a.getFormSubmitHandler)(f, y)), window.addEventListener("message", (0, a.getFormThemeHandler)(f, function (e) {
                      var t;
                      if (null == e ? void 0 : e.theme) {
                        var n = document.querySelector(".tf-v1-close-icon");
                        n && (n.style.color = null === (t = e.theme) || void 0 === t ? void 0 : t.color);
                      }
                    })), window.addEventListener("message", (0, a.getThankYouScreenButtonClickHandler)(f, w)), "widget" !== e && window.addEventListener("message", u.dispatchCustomKeyEventFromIframe), x && window.addEventListener("message", (0, a.getFormReadyHandler)(f, function () {
                      (0, r.setupGaInstance)(_, f, x);
                    })), {
                      iframe: _,
                      embedId: f,
                      refresh: function () {
                        return (0, c.refreshIframe)(_);
                      },
                      focus: function () {
                        var e;
                        null === (e = _.contentWindow) || void 0 === e || e.postMessage("embed-focus", "*");
                      }
                    };
                  };
                },
                8866: function (e, t) {
                  var n = this && this.__read || function (e, t) {
                    var n = "function" == typeof Symbol && e[Symbol.iterator];
                    if (!n) return e;
                    var o,
                      r,
                      i = n.call(e),
                      a = [];
                    try {
                      for (; (void 0 === t || t-- > 0) && !(o = i.next()).done;) a.push(o.value);
                    } catch (e) {
                      r = {
                        error: e
                      };
                    } finally {
                      try {
                        o && !o.done && (n = i.return) && n.call(i);
                      } finally {
                        if (r) throw r.error;
                      }
                    }
                    return a;
                  };
                  Object.defineProperty(t, "__esModule", {
                    value: !0
                  }), t.generateEmbedId = void 0, t.generateEmbedId = function () {
                    var e = Math.random();
                    return n(String(e).split("."), 2)[1];
                  };
                },
                8554: function (e, t) {
                  var n = this && this.__rest || function (e, t) {
                    var n = {};
                    for (var o in e) Object.prototype.hasOwnProperty.call(e, o) && t.indexOf(o) < 0 && (n[o] = e[o]);
                    if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
                      var r = 0;
                      for (o = Object.getOwnPropertySymbols(e); r < o.length; r++) t.indexOf(o[r]) < 0 && Object.prototype.propertyIsEnumerable.call(e, o[r]) && (n[o[r]] = e[o[r]]);
                    }
                    return n;
                  };
                  function o(e, t, o) {
                    return function (r) {
                      var i = r.data,
                        a = i.type,
                        s = i.embedId,
                        u = n(i, ["type", "embedId"]);
                      a === e && s === t && (null == o || o(u));
                    };
                  }
                  Object.defineProperty(t, "__esModule", {
                    value: !0
                  }), t.getThankYouScreenButtonClickHandler = t.getFormThemeHandler = t.getWelcomeScreenHiddenHandler = t.getFormSubmitHandler = t.getFormHeightChangedHandler = t.getFormQuestionChangedHandler = t.getFormStartedHandler = t.getFormReadyHandler = void 0, t.getFormReadyHandler = function (e, t) {
                    return o("form-ready", e, t);
                  }, t.getFormStartedHandler = function (e, t) {
                    return o("form-started", e, t);
                  }, t.getFormQuestionChangedHandler = function (e, t) {
                    return o("form-screen-changed", e, t);
                  }, t.getFormHeightChangedHandler = function (e, t) {
                    return o("form-height-changed", e, t);
                  }, t.getFormSubmitHandler = function (e, t) {
                    return o("form-submit", e, t);
                  }, t.getWelcomeScreenHiddenHandler = function (e, t) {
                    return o("welcome-screen-hidden", e, t);
                  }, t.getFormThemeHandler = function (e, t) {
                    return o("form-theme", e, t);
                  }, t.getThankYouScreenButtonClickHandler = function (e, t) {
                    return o("thank-you-screen-button-click", e, t);
                  };
                },
                339: function (e, t, n) {
                  var o = this && this.__createBinding || (Object.create ? function (e, t, n, o) {
                      void 0 === o && (o = n);
                      var r = Object.getOwnPropertyDescriptor(t, n);
                      r && !("get" in r ? !t.__esModule : r.writable || r.configurable) || (r = {
                        enumerable: !0,
                        get: function () {
                          return t[n];
                        }
                      }), Object.defineProperty(e, o, r);
                    } : function (e, t, n, o) {
                      void 0 === o && (o = n), e[o] = t[n];
                    }),
                    r = this && this.__exportStar || function (e, t) {
                      for (var n in e) "default" === n || Object.prototype.hasOwnProperty.call(t, n) || o(t, e, n);
                    };
                  Object.defineProperty(t, "__esModule", {
                    value: !0
                  }), r(n(1553), t), r(n(7144), t);
                },
                5511: function (e, t) {
                  Object.defineProperty(t, "__esModule", {
                    value: !0
                  }), t.refreshIframe = void 0, t.refreshIframe = function (e) {
                    if (e) {
                      var t = e.src;
                      if (t.includes("&refresh")) {
                        var n = t.split("&refresh#");
                        e.src = n.join("#");
                      } else (n = t.split("#"))[0] = "".concat(n[0], "&refresh"), e.src = n.join("#");
                    }
                  };
                },
                7144: function (e, t) {
                  var n = this && this.__awaiter || function (e, t, n, o) {
                      return new (n || (n = Promise))(function (r, i) {
                        function a(e) {
                          try {
                            u(o.next(e));
                          } catch (e) {
                            i(e);
                          }
                        }
                        function s(e) {
                          try {
                            u(o.throw(e));
                          } catch (e) {
                            i(e);
                          }
                        }
                        function u(e) {
                          var t;
                          e.done ? r(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
                            e(t);
                          })).then(a, s);
                        }
                        u((o = o.apply(e, t || [])).next());
                      });
                    },
                    o = this && this.__generator || function (e, t) {
                      var n,
                        o,
                        r,
                        i,
                        a = {
                          label: 0,
                          sent: function () {
                            if (1 & r[0]) throw r[1];
                            return r[1];
                          },
                          trys: [],
                          ops: []
                        };
                      return i = {
                        next: s(0),
                        throw: s(1),
                        return: s(2)
                      }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
                        return this;
                      }), i;
                      function s(s) {
                        return function (u) {
                          return function (s) {
                            if (n) throw new TypeError("Generator is already executing.");
                            for (; i && (i = 0, s[0] && (a = 0)), a;) try {
                              if (n = 1, o && (r = 2 & s[0] ? o.return : s[0] ? o.throw || ((r = o.return) && r.call(o), 0) : o.next) && !(r = r.call(o, s[1])).done) return r;
                              switch (o = 0, r && (s = [2 & s[0], r.value]), s[0]) {
                                case 0:
                                case 1:
                                  r = s;
                                  break;
                                case 4:
                                  return a.label++, {
                                    value: s[1],
                                    done: !1
                                  };
                                case 5:
                                  a.label++, o = s[1], s = [0];
                                  continue;
                                case 7:
                                  s = a.ops.pop(), a.trys.pop();
                                  continue;
                                default:
                                  if (!((r = (r = a.trys).length > 0 && r[r.length - 1]) || 6 !== s[0] && 2 !== s[0])) {
                                    a = 0;
                                    continue;
                                  }
                                  if (3 === s[0] && (!r || s[1] > r[0] && s[1] < r[3])) {
                                    a.label = s[1];
                                    break;
                                  }
                                  if (6 === s[0] && a.label < r[1]) {
                                    a.label = r[1], r = s;
                                    break;
                                  }
                                  if (r && a.label < r[2]) {
                                    a.label = r[2], a.ops.push(s);
                                    break;
                                  }
                                  r[2] && a.ops.pop(), a.trys.pop();
                                  continue;
                              }
                              s = t.call(e, a);
                            } catch (e) {
                              s = [6, e], o = 0;
                            } finally {
                              n = r = 0;
                            }
                            if (5 & s[0]) throw s[1];
                            return {
                              value: s[0] ? s[1] : void 0,
                              done: !0
                            };
                          }([s, u]);
                        };
                      }
                    };
                  Object.defineProperty(t, "__esModule", {
                    value: !0
                  }), t.dispatchCustomKeyEventFromIframe = t.removeCustomKeyboardListener = t.addCustomKeyboardListener = void 0;
                  var r = "Escape",
                    i = function (e, i) {
                      return n(void 0, void 0, void 0, function () {
                        return o(this, function (n) {
                          return e.code === r && "function" == typeof i && (i(), (0, t.removeCustomKeyboardListener)()), [2];
                        });
                      });
                    };
                  t.addCustomKeyboardListener = function (e) {
                    return window.document.addEventListener("keydown", function (t) {
                      return i(t, e);
                    });
                  }, t.removeCustomKeyboardListener = function () {
                    return window.document.removeEventListener("keydown", i);
                  }, t.dispatchCustomKeyEventFromIframe = function (e) {
                    "form-close" === e.data.type && window.document.dispatchEvent(new KeyboardEvent("keydown", {
                      code: r
                    }));
                  };
                },
                2256: function (e, t) {
                  Object.defineProperty(t, "__esModule", {
                    value: !0
                  }), t.triggerIframeRedraw = void 0, t.triggerIframeRedraw = function () {
                    this.style.transform = "translateZ(0)";
                  };
                },
                8939: function (e, t, n) {
                  Object.defineProperty(t, "__esModule", {
                    value: !0
                  }), t.getTextColor = void 0;
                  var o = n(2938);
                  t.getTextColor = function (e) {
                    if (!e) return "#FFFFFF";
                    var t = e.startsWith("#") ? (0, o.hexRgb)(e) : function (e) {
                        var t = {
                            red: 0,
                            green: 0,
                            blue: 0
                          },
                          n = e.match(/\d+/g);
                        return n && (t.red = parseInt(n[0], 10), t.green = parseInt(n[0], 10), t.blue = parseInt(n[0], 10)), t;
                      }(e),
                      n = t.red,
                      r = t.green,
                      i = t.blue;
                    return Math.round((299 * n + 587 * r + 114 * i) / 1e3) > 150 ? "#000000" : "#FFFFFF";
                  };
                },
                2698: function (e, t) {
                  var n = this && this.__assign || function () {
                    return n = Object.assign || function (e) {
                      for (var t, n = 1, o = arguments.length; n < o; n++) for (var r in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
                      return e;
                    }, n.apply(this, arguments);
                  };
                  Object.defineProperty(t, "__esModule", {
                    value: !0
                  }), t.getTransitiveSearchParams = void 0, t.getTransitiveSearchParams = function (e) {
                    var t = new URL(window.location.href);
                    return "boolean" == typeof e && e ? Object.fromEntries(t.searchParams.entries()) : Array.isArray(e) && e.length > 0 ? e.reduce(function (e, o) {
                      var r,
                        i = t.searchParams.get(o);
                      return i ? n(n({}, e), ((r = {})[o] = i, r)) : e;
                    }, {}) : {};
                  };
                },
                8252: function (e, t) {
                  Object.defineProperty(t, "__esModule", {
                    value: !0
                  }), t.hasDom = void 0, t.hasDom = function () {
                    return "undefined" != typeof document && "undefined" != typeof window;
                  };
                },
                2938: function (e, t) {
                  Object.defineProperty(t, "__esModule", {
                    value: !0
                  }), t.hexRgb = void 0;
                  var n = "a-f\\d",
                    o = "#?[".concat(n, "]{3}[").concat(n, "]?"),
                    r = "#?[".concat(n, "]{6}([").concat(n, "]{2})?"),
                    i = new RegExp("[^#".concat(n, "]"), "gi"),
                    a = new RegExp("^".concat(o, "$|^").concat(r, "$"), "i");
                  t.hexRgb = function (e) {
                    if ("string" != typeof e || i.test(e) || !a.test(e)) throw new TypeError("Expected a valid hex string");
                    8 === (e = e.replace(/^#/, "")).length && (e = e.slice(0, 6)), 4 === e.length && (e = e.slice(0, 3)), 3 === e.length && (e = e[0] + e[0] + e[1] + e[1] + e[2] + e[2]);
                    var t = Number.parseInt(e, 16);
                    return {
                      red: t >> 16,
                      green: t >> 8 & 255,
                      blue: 255 & t
                    };
                  };
                },
                863: function (e, t, n) {
                  var o = this && this.__awaiter || function (e, t, n, o) {
                      return new (n || (n = Promise))(function (r, i) {
                        function a(e) {
                          try {
                            u(o.next(e));
                          } catch (e) {
                            i(e);
                          }
                        }
                        function s(e) {
                          try {
                            u(o.throw(e));
                          } catch (e) {
                            i(e);
                          }
                        }
                        function u(e) {
                          var t;
                          e.done ? r(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
                            e(t);
                          })).then(a, s);
                        }
                        u((o = o.apply(e, t || [])).next());
                      });
                    },
                    r = this && this.__generator || function (e, t) {
                      var n,
                        o,
                        r,
                        i,
                        a = {
                          label: 0,
                          sent: function () {
                            if (1 & r[0]) throw r[1];
                            return r[1];
                          },
                          trys: [],
                          ops: []
                        };
                      return i = {
                        next: s(0),
                        throw: s(1),
                        return: s(2)
                      }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
                        return this;
                      }), i;
                      function s(s) {
                        return function (u) {
                          return function (s) {
                            if (n) throw new TypeError("Generator is already executing.");
                            for (; i && (i = 0, s[0] && (a = 0)), a;) try {
                              if (n = 1, o && (r = 2 & s[0] ? o.return : s[0] ? o.throw || ((r = o.return) && r.call(o), 0) : o.next) && !(r = r.call(o, s[1])).done) return r;
                              switch (o = 0, r && (s = [2 & s[0], r.value]), s[0]) {
                                case 0:
                                case 1:
                                  r = s;
                                  break;
                                case 4:
                                  return a.label++, {
                                    value: s[1],
                                    done: !1
                                  };
                                case 5:
                                  a.label++, o = s[1], s = [0];
                                  continue;
                                case 7:
                                  s = a.ops.pop(), a.trys.pop();
                                  continue;
                                default:
                                  if (!((r = (r = a.trys).length > 0 && r[r.length - 1]) || 6 !== s[0] && 2 !== s[0])) {
                                    a = 0;
                                    continue;
                                  }
                                  if (3 === s[0] && (!r || s[1] > r[0] && s[1] < r[3])) {
                                    a.label = s[1];
                                    break;
                                  }
                                  if (6 === s[0] && a.label < r[1]) {
                                    a.label = r[1], r = s;
                                    break;
                                  }
                                  if (r && a.label < r[2]) {
                                    a.label = r[2], a.ops.push(s);
                                    break;
                                  }
                                  r[2] && a.ops.pop(), a.trys.pop();
                                  continue;
                              }
                              s = t.call(e, a);
                            } catch (e) {
                              s = [6, e], o = 0;
                            } finally {
                              n = r = 0;
                            }
                            if (5 & s[0]) throw s[1];
                            return {
                              value: s[0] ? s[1] : void 0,
                              done: !0
                            };
                          }([s, u]);
                        };
                      }
                    };
                  Object.defineProperty(t, "__esModule", {
                    value: !0
                  }), t.waitForHubspotCookie = t.getHubspotHiddenFields = t.getHubspotCookieValue = void 0;
                  var i = n(4623);
                  t.getHubspotCookieValue = function () {
                    var e = document.cookie.match(new RegExp("(^| )".concat("hubspotutk", "=([^;]+)")));
                    return e && e[2] || void 0;
                  }, t.getHubspotHiddenFields = function () {
                    return {
                      hubspot_page_name: document.title,
                      hubspot_page_url: window.location.href,
                      hubspot_utk: (0, t.getHubspotCookieValue)()
                    };
                  }, t.waitForHubspotCookie = function () {
                    return o(void 0, void 0, void 0, function () {
                      var e, n;
                      return r(this, function (o) {
                        switch (o.label) {
                          case 0:
                            e = 10, n = 0, o.label = 1;
                          case 1:
                            return !(0, t.getHubspotCookieValue)() && n < e ? [4, (0, i.sleep)(250)] : [3, 4];
                          case 2:
                            o.sent(), o.label = 3;
                          case 3:
                            return n++, [3, 1];
                          case 4:
                            return [2];
                        }
                      });
                    });
                  };
                },
                9071: function (e, t) {
                  Object.defineProperty(t, "__esModule", {
                    value: !0
                  }), t.includeCss = void 0, t.includeCss = function (e) {
                    var t = function (e) {
                      return "".concat("https://embed.typeform.com/next/css/").concat(e);
                    }(e);
                    if (!document.querySelector('link[href="'.concat(t, '"]'))) {
                      var n = document.createElement("link");
                      n.rel = "stylesheet", n.href = t, document.head.append(n);
                    }
                  };
                },
                6797: function (e, t, n) {
                  var o = this && this.__createBinding || (Object.create ? function (e, t, n, o) {
                      void 0 === o && (o = n);
                      var r = Object.getOwnPropertyDescriptor(t, n);
                      r && !("get" in r ? !t.__esModule : r.writable || r.configurable) || (r = {
                        enumerable: !0,
                        get: function () {
                          return t[n];
                        }
                      }), Object.defineProperty(e, o, r);
                    } : function (e, t, n, o) {
                      void 0 === o && (o = n), e[o] = t[n];
                    }),
                    r = this && this.__exportStar || function (e, t) {
                      for (var n in e) "default" === n || Object.prototype.hasOwnProperty.call(t, n) || o(t, e, n);
                    };
                  Object.defineProperty(t, "__esModule", {
                    value: !0
                  }), r(n(3626), t), r(n(339), t), r(n(8252), t), r(n(9071), t), r(n(2346), t), r(n(7377), t), r(n(6563), t), r(n(4527), t), r(n(9533), t), r(n(1451), t), r(n(8972), t), r(n(4748), t), r(n(4392), t), r(n(8939), t), r(n(9917), t), r(n(1987), t), r(n(2391), t), r(n(863), t), r(n(6890), t), r(n(5084), t);
                },
                6890: function (e, t) {
                  Object.defineProperty(t, "__esModule", {
                    value: !0
                  }), t.invokeWithoutDefault = void 0, t.invokeWithoutDefault = function (e) {
                    return function (t) {
                      null == t || t.preventDefault(), e();
                    };
                  };
                },
                2346: function (e, t) {
                  Object.defineProperty(t, "__esModule", {
                    value: !0
                  }), t.isDefined = void 0, t.isDefined = function (e) {
                    return null != e;
                  };
                },
                1987: function (e, t) {
                  Object.defineProperty(t, "__esModule", {
                    value: !0
                  }), t.isVisible = t.isInPage = t.isOpen = void 0, t.isOpen = function (e) {
                    return (0, t.isInPage)(e) && (0, t.isVisible)(e);
                  }, t.isInPage = function (e) {
                    return !!e.parentNode;
                  }, t.isVisible = function (e) {
                    return "none" !== e.style.display;
                  };
                },
                9917: function (e, t) {
                  Object.defineProperty(t, "__esModule", {
                    value: !0
                  }), t.lazyInitialize = void 0, t.lazyInitialize = function (e, t) {
                    var n = new IntersectionObserver(function (e) {
                      e.forEach(function (e) {
                        e.isIntersecting && (t(), n.unobserve(e.target));
                      });
                    });
                    n.observe(e);
                  };
                },
                7377: function (e, t) {
                  var n = this && this.__assign || function () {
                      return n = Object.assign || function (e) {
                        for (var t, n = 1, o = arguments.length; n < o; n++) for (var r in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
                        return e;
                      }, n.apply(this, arguments);
                    },
                    o = this && this.__read || function (e, t) {
                      var n = "function" == typeof Symbol && e[Symbol.iterator];
                      if (!n) return e;
                      var o,
                        r,
                        i = n.call(e),
                        a = [];
                      try {
                        for (; (void 0 === t || t-- > 0) && !(o = i.next()).done;) a.push(o.value);
                      } catch (e) {
                        r = {
                          error: e
                        };
                      } finally {
                        try {
                          o && !o.done && (n = i.return) && n.call(i);
                        } finally {
                          if (r) throw r.error;
                        }
                      }
                      return a;
                    };
                  Object.defineProperty(t, "__esModule", {
                    value: !0
                  }), t.loadOptionsFromAttributes = t.transformAttributeValue = t.camelCaseToKebabCase = void 0, t.camelCaseToKebabCase = function (e) {
                    return e.split("").map(function (e, t) {
                      return e.toUpperCase() === e ? "".concat(0 !== t ? "-" : "").concat(e.toLowerCase()) : e;
                    }).join("");
                  };
                  var r = function (e) {
                      return e || void 0;
                    },
                    i = function (e) {
                      if (null !== e) return "" === e || "yes" === e || "true" === e;
                    },
                    a = function (e) {
                      var t = e ? parseInt(e, 10) : NaN;
                      return isNaN(t) ? void 0 : t;
                    },
                    s = "%ESCAPED_COMMA%",
                    u = function (e) {
                      if (e) return e.replace(/\s/g, "").replace(/\\,/g, s).split(",").filter(function (e) {
                        return !!e;
                      }).map(function (e) {
                        return e.replace(s, ",");
                      });
                    };
                  t.transformAttributeValue = function (e, t) {
                    var c, l, d;
                    switch (t) {
                      case "string":
                        return r(e);
                      case "boolean":
                        return i(e);
                      case "integer":
                        return a(e);
                      case "function":
                        return function (e) {
                          var t = e && e in window ? window[e] : void 0;
                          return "function" == typeof t ? t : void 0;
                        }(e);
                      case "array":
                        return u(e);
                      case "record":
                        return function (e) {
                          if (e) return e.replace(/\\,/g, s).split(",").filter(function (e) {
                            return !!e;
                          }).map(function (e) {
                            return e.replace(s, ",");
                          }).reduce(function (e, t) {
                            var r,
                              i = t.match(/^([^=]+)=(.*)$/);
                            if (i) {
                              var a = o(i, 3),
                                s = a[1],
                                u = a[2];
                              return n(n({}, e), ((r = {})[s.trim()] = u, r));
                            }
                            return e;
                          }, {});
                        }(e);
                      case "integerOrString":
                        return function (e) {
                          if (e) return e.match(/^[0-9]+$/) ? a(e) : r(e);
                        }(e);
                      case "integerOrBoolean":
                        return null !== (c = a(e)) && void 0 !== c ? c : i(e);
                      case "stringOrBoolean":
                        return null !== (l = r(e)) && void 0 !== l ? l : i(e);
                      case "arrayOrBoolean":
                        return null !== (d = u(e)) && void 0 !== d ? d : i(e);
                      default:
                        throw new Error("Invalid attribute transformation ".concat(t));
                    }
                  }, t.loadOptionsFromAttributes = function (e, o) {
                    return Object.keys(o).reduce(function (r, i) {
                      var a;
                      return n(n({}, r), ((a = {})[i] = (0, t.transformAttributeValue)(e.getAttribute("data-tf-".concat((0, t.camelCaseToKebabCase)(i))), o[i]), a));
                    }, {});
                  };
                },
                6563: function (e, t) {
                  Object.defineProperty(t, "__esModule", {
                    value: !0
                  }), t.isFullscreen = t.isMobile = t.isBigScreen = void 0, t.isBigScreen = function () {
                    return window.screen.width >= 1024 && window.screen.height >= 768;
                  }, t.isMobile = function () {
                    return /mobile|tablet|android/i.test(navigator.userAgent.toLowerCase());
                  }, t.isFullscreen = function () {
                    return (0, t.isMobile)() && !(0, t.isBigScreen)();
                  };
                },
                4527: function (e, t, n) {
                  var o = this && this.__assign || function () {
                      return o = Object.assign || function (e) {
                        for (var t, n = 1, o = arguments.length; n < o; n++) for (var r in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
                        return e;
                      }, o.apply(this, arguments);
                    },
                    r = this && this.__read || function (e, t) {
                      var n = "function" == typeof Symbol && e[Symbol.iterator];
                      if (!n) return e;
                      var o,
                        r,
                        i = n.call(e),
                        a = [];
                      try {
                        for (; (void 0 === t || t-- > 0) && !(o = i.next()).done;) a.push(o.value);
                      } catch (e) {
                        r = {
                          error: e
                        };
                      } finally {
                        try {
                          o && !o.done && (n = i.return) && n.call(i);
                        } finally {
                          if (r) throw r.error;
                        }
                      }
                      return a;
                    };
                  Object.defineProperty(t, "__esModule", {
                    value: !0
                  }), t.removeUndefinedKeys = void 0;
                  var i = n(2346);
                  t.removeUndefinedKeys = function (e) {
                    return Object.entries(e).filter(function (e) {
                      var t = r(e, 2)[1];
                      return (0, i.isDefined)(t);
                    }).reduce(function (e, t) {
                      var n,
                        i = r(t, 2),
                        a = i[0],
                        s = i[1];
                      return o(o({}, e), ((n = {})[a] = s, n));
                    }, {});
                  };
                },
                4748: function (e, t, n) {
                  Object.defineProperty(t, "__esModule", {
                    value: !0
                  }), t.setAutoClose = t.DEFAULT_AUTO_CLOSE_TIME = void 0;
                  var o = n(8554);
                  t.DEFAULT_AUTO_CLOSE_TIME = 500, t.setAutoClose = function (e, n, r) {
                    n && r && window.addEventListener("message", (0, o.getFormSubmitHandler)(e, function () {
                      return setTimeout(r, (o = "number" == typeof (e = n) ? e : 0, Math.max(o, t.DEFAULT_AUTO_CLOSE_TIME)));
                      var e, o;
                    }));
                  };
                },
                9533: function (e, t) {
                  Object.defineProperty(t, "__esModule", {
                    value: !0
                  }), t.setElementSize = t.getValueWithUnits = void 0, t.getValueWithUnits = function (e) {
                    return "string" != typeof e || e.match(/^[0-9]+$/) ? "".concat(e, "px") : e;
                  }, t.setElementSize = function (e, n) {
                    var o = n.width,
                      r = n.height;
                    return o && (e.style.width = (0, t.getValueWithUnits)(o)), r && (e.style.height = (0, t.getValueWithUnits)(r)), e;
                  };
                },
                4392: function (e, t) {
                  Object.defineProperty(t, "__esModule", {
                    value: !0
                  }), t.setupGaInstance = t.sendGaIdMessage = void 0, t.sendGaIdMessage = function (e, t, n) {
                    var o = {
                      embedId: e,
                      gaClientId: t
                    };
                    setTimeout(function () {
                      n && n.contentWindow && n.contentWindow.postMessage({
                        type: "ga-client-id",
                        data: o
                      }, "*");
                    }, 0);
                  };
                  var n = function (e) {
                      console.error(e);
                    },
                    o = function (e) {
                      n("Whoops! You enabled the shareGaInstance feature in your typeform embed but ".concat(e, ".\n\n") + "Make sure to include Google Analytics Javascript code before the Typeform Embed Javascript code in your page and use correct tracker ID.\n\nIt is also possible the Google Analytics was blocked by your adblock plugin.");
                    };
                  t.setupGaInstance = function (e, r, i) {
                    var a = "string" == typeof i ? i : void 0;
                    if (window.gtag) {
                      if (a || (a = function () {
                        if (window.dataLayer) {
                          var e = window.dataLayer.find(function (e) {
                            return e.length > 1 && "config" === e[0];
                          });
                          return e && e[1];
                        }
                      }()), !a) return void o("the tracking ID could not be retrieved");
                      var s = !1;
                      window.gtag("get", a, "client_id", function (n) {
                        s = !0, (0, t.sendGaIdMessage)(r, n, e);
                      }), setTimeout(function () {
                        s || o("the tracker with ID ".concat(a, " was not found"));
                      }, 3e3);
                    } else try {
                      var u = function (e, t) {
                        return t ? e.find(function (e) {
                          return e.get("trackingId") === t;
                        }) : e[0];
                      }(window.ga.getAll(), a);
                      u ? (0, t.sendGaIdMessage)(r, u.get("clientId"), e) : o("the tracker with ID ".concat(a, " was not found"));
                    } catch (e) {
                      o("the Google Analytics object was not found"), n(e);
                    }
                  };
                },
                4623: function (e, t) {
                  Object.defineProperty(t, "__esModule", {
                    value: !0
                  }), t.sleep = void 0, t.sleep = function (e) {
                    return new Promise(function (t) {
                      return setTimeout(t, e);
                    });
                  };
                },
                1451: function (e, t) {
                  Object.defineProperty(t, "__esModule", {
                    value: !0
                  }), t.unmountElement = void 0, t.unmountElement = function (e) {
                    var t;
                    null === (t = e.parentNode) || void 0 === t || t.removeChild(e);
                  };
                }
              },
              t = {};
            return function n(o) {
              var r = t[o];
              if (void 0 !== r) return r.exports;
              var i = t[o] = {
                exports: {}
              };
              return e[o].call(i.exports, i, i.exports, n), i.exports;
            }(1920);
          }();
        },
        156: function (t) {
          "use strict";

          t.exports = e;
        }
      },
      n = {};
    function o(e) {
      var r = n[e];
      if (void 0 !== r) return r.exports;
      var i = n[e] = {
        exports: {}
      };
      return t[e].call(i.exports, i, i.exports, o), i.exports;
    }
    o.g = function () {
      if ("object" == typeof globalThis) return globalThis;
      try {
        return this || new Function("return this")();
      } catch (e) {
        if ("object" == typeof window) return window;
      }
    }(), o.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, o.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    };
    var r = {};
    return function () {
      "use strict";

      var e = r;
      Object.defineProperty(e, "__esModule", {
        value: !0
      }), e.Sidetab = e.Popover = e.SliderButton = e.PopupButton = e.Widget = void 0;
      var t = o(611),
        n = o(281),
        i = o(797),
        a = (0, i.memoComponent)(n.Widget);
      e.Widget = a;
      var s = (0, i.memoComponent)((0, n.makeButtonComponent)(t.createPopup, "popup"));
      e.PopupButton = s;
      var u = (0, i.memoComponent)((0, n.makeButtonComponent)(t.createSlider, "slider"));
      e.SliderButton = u;
      var c = (0, i.memoComponent)((0, n.makeInitializerComponent)(t.createPopover, "popover"));
      e.Popover = c;
      var l = (0, i.memoComponent)((0, n.makeInitializerComponent)(t.createSidetab, "sidetab"));
      e.Sidetab = l;
    }(), r;
  }();
});